export default {
    'A name is required': 'A name is required',
    Age: 'Age',
    'Total money spent, $': 'Total money spent, $',
    Clients: 'Clients',
    Income: 'Income',
    'First name': 'First name',
    'Last name': 'Last name',
    Position: 'Position',
    'Click para seleccionar ': 'Click to select',
    Notifications: 'Notifications',
    Yes: 'Yes',
    No: 'No',
    'City, country': 'City, country',
    Address: 'Address',
    Birthday: 'Birthday',
    'Click to add tags': 'Click to add tags',
    Notes: 'Notes',
    Reset: 'Reset',
    Save: 'Save',
    'Top clients': 'Top clients',
    'Money spent, $': 'Money spent, $',
    '-- Not selected --': '-- Not selected --',
    'Sales manager': 'Sales manager',
    'Customer service': 'Customer service',
    'General manager': 'General manager',
    New: 'New',
    Customer: 'Customer',
    Supplier: 'Supplier',
    Discount: 'Discount',
    'Old Buddy': 'Old Buddy',
    'Avid Supporter': 'Avid Supporter',
    Date: 'Date',
    Payment: 'Payment',
    Purchase: 'Purchase',
    Sum: 'Sum',
    Left: 'Left',
    'Nothing on this day': 'Nothing on this day',
    Information: 'Information',
    Statistics: 'Statistics',
    Transactions: 'Transactions',
    Customers: 'Customers',
    Charts: 'Charts',
    'See all notifications': 'See all notifications',
    'Deposits News': 'Deposits News',
    'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...':
        'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...',
    'Search Improved': 'Search Improved',
    'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...':
        'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...',
    'Transaction Reports': 'Transaction Reports',
    'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...':
        'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...',
    Warning: 'Warning',
    'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.':
        'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.',
    'Editing customers data': 'Editing customers data',
    'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.':
        'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.',
    'We miss you': 'We miss you',
    'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.':
        'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.',
    'Have a nice day': 'Have a nice day',
    'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.':
        'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.',
    Localization: 'Localization',
    'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.':
        'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.',
    'We love you': 'We love you',
    'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.':
        'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.',
    Persons: 'Persons',
    'Click twice to see more goodies': 'Click twice to see more goodies',
    Saved: 'Saved',
    Settings: 'General Settings',
    'Regional settings': 'Regional settings',
    Language: 'Language',
    'Date format': 'Date format',
    'Money format': 'Money format',
    'Environment settings': 'Environment settings',
    Theme: 'Theme',
    Light: 'Light',
    Dark: 'Dark',
    'Max list length': 'Max list length',
    'Default settings': 'Default settings',
    'Open latest notifications': 'Open latest notifications',
    'Go to settings': 'Go to settings',
    All: 'All',
    Payments: 'Payments',
    Incoming: 'Incoming',
    Email: 'Email',
    Widgets: 'Widgets',
    Demos: 'Demos',
    Prices: 'Prices',
    Tutorials: 'Tutorials',
    'Tirane, Albania': 'Tirane, Albania',
    'Buenos Aires, Argentina': 'Buenos Aires, Argentina',
    'Canberra, Australia': 'Canberra, Australia',
    'Vienna, Austria': 'Vienna, Austria',
    'Minsk, Belarus': 'Minsk, Belarus',
    'Brussels, Belgium': 'Brussels, Belgium',
    'Brasilia, Brazil': 'Brasilia, Brazil',
    'Ottawa, Canada': 'Ottawa, Canada',
    'Beijing, China': 'Beijing, China',
    'Prague, Czech Republic': 'Prague, Czech Republic',
    'Copenhagen, Denmark': 'Copenhagen, Denmark',
    'Cairo, Egypt': 'Cairo, Egypt',
    'Helsinki, Finland': 'Helsinki, Finland',
    'Paris, France': 'Paris, France',
    'Tbilisi, Georgia': 'Tbilisi, Georgia',
    'Berlin, Germany': 'Berlin, Germany',
    'New Delhi, India': 'New Delhi, India',
    'Dublin, Ireland': 'Dublin, Ireland',
    'Rome, Italy': 'Rome, Italy',
    'Tokyo, Japan': 'Tokyo, Japan',
    'Wellington, New Zealand': 'Wellington, New Zealand',
    'Seoul, Republic of Korea': 'Seoul, Republic of Korea',
    'Madrid, Spain': 'Madrid, Spain',
    'Stockholm, Sweden': 'Stockholm, Sweden',
    'Washington, United States': 'Washington, United States',
    'Payment History': 'Payment History',
    'Origin of clients': 'Origin of clients',
    'Income from various age groups': 'Income from various age groups',
    'Awarded Badges': 'Awarded Badges',
    'Clients by occupation': 'Clients by occupation',
    'No new notifications': 'No new notifications',

    'Añadir Egreso': 'Add expense',
    'Añadir Ingreso': 'Add Income',
    'Saldo Recargas:': 'Balance Recharges:',
    'Saldo Juego:': 'Balance Game:',
    Nombre: 'Name',
    Hoy: 'Today',
    Ayer: 'Yesterday',
    'Ultimos 30 días': 'Last 30 days',
    Depósitos: 'Deposits',
    Retiros: 'Withdrawal',
    Neto: 'Net',
    'Advertencia!': 'Warning!',
    'Desea cambiar la contraseña?': 'Do you want to change the password?',
    Salir: 'Cancel',
    Descripción: 'Description',
    Activado: 'Active',
    Inactivado: 'Inactive',

    'Número de usuario': 'User Number',
    'Login para acceso': 'Login for access',
    'Última dirección IP': 'Last IP address',
    'Último usuario modif': 'Last user modif',
    Tipo: 'Type',
    Agente: 'Agent',
    Afiliado: 'Affiliate',
    'Click para seleccionar': 'Click to select',
    Estado: 'Status',
    Activo: 'Active',
    Inactivo: 'Inactive',
    Retirado: 'Retired',
    'Idioma preferido:': 'Preferred language:',
    'Nombre del usuario': 'Username',
    País: 'Country',
    'Campo Requerido': 'Required Field',
    Moneda: 'Currency',
    'Fecha de creación': 'Creation date',
    'Última Fecha modif': 'Last Modified Date',
    'Estado especial': 'Special State',
    Pinagent: 'Pinagent',
    'Bloqueado para ventas': 'Locked for sales',
    'Imprime recibo caja': 'Print Receipt',
    'Permite recargas': 'Allow deposits',
    'Permite activar reg': 'Allows Reg. Activation',
    'Nombre del contacto': 'Contact Name',
    'Correo electrónico': 'Email',
    Teléfono: 'Phone Number',
    Concesionario: 'Agent',
    Subconcesionario: 'SubAgent',
    'Provincia/Región': 'Province / Region / State',
    Dirección: 'Address',
    Barrio: 'Neighborhood',
    'Limite diario de recargas': 'Daily limit of recharges',
    'Comisión recargas': 'Deposit Commission',
    'Apuesta mínima': 'Minimum bet',
    'Límite diario': 'Daily limit',
    'Datos Principales': 'Main Data',
    'Datos Agente': 'Agent Data',
    'Datos Configuracion': 'Configuration Data',
    Limpiar: 'Reset',
    Guardar: 'Save',
    'Completa los campos...': 'Complete the fields...',
    'Mi Información': 'My Information',
    'Contraseña Actual': 'Current Password',
    'Nueva Contraseña': 'New Password',
    'The password must contain a minimum of 8 characters, a lowercase, an uppercase and a number.':
        'The password must contain a minimum of 8 characters, a lowercase, an uppercase and a number.',
    'Confirmar Contraseña': 'Confirm Password',
    'Contraseñas no coinciden': 'Passwords do not match',
    'Contraseña cambiada satisfactoriamente': 'Password changed successfully',
    '¡Exito!': '¡Success!',
    'Nueva contraseñas no coinciden': 'New passwords do not match',
    'Verifique los campos...': 'Verify the fields...',
    'Cambiar mi contraseña': 'Change my password',
    Slug: 'Slug',
    Superior: 'Higher',
    'Editar Categoría': 'Edit Category',
    Cancelar: 'Cancel',
    'Categoría Editada': 'Edited Category',
    'Añadir Categoría': 'Add Category',
    'Categoría Agregada': 'Added Category',
    Todos: 'All',
    'Filtros Avanzados': 'Advanced Filters',
    Consultar: 'Apply',
    Categoría: 'Category',
    Productos: 'Products',
    'Agragar Categoría Producto': 'Add Product Category',
    'Categoría Producto Editada': 'Edited Product Category',
    'Editar Categorias Productos': 'Edit Products Categories',
    'Categoría Producto Agregada': 'Product Category Added',
    Categorías: 'Categories',
    'Añadir Categoría Producto': 'Add Product Category',
    'Nombre Encargado': 'Name in Charge',
    Nit: 'Nit',
    'Es propio?': 'Is it your own?',
    'Añadir Tipo Producto Partner': 'Add Partner Product Type',
    'Partner Agregado': 'Partner Added',
    'Añadir Partner': 'Add Partner',
    Producto: 'Product',
    Proveedor: 'Provider',
    Partner: 'Partner',
    Verificado: 'Verified',
    'Filtro País': 'Country Filter',
    Mobile: 'Mobile',
    Escritorio: 'Desktop',
    Máximo: 'Maximum',
    Mínimo: 'Minimum',
    'Tiempo Procesamiento': 'Processing Time',
    Orden: 'Order',
    'Orden Destacado': 'Featured Order',
    Filas: 'Rows',
    Columnas: 'Columns',
    'Editar Productos Partner': 'Edit Partner Products',
    'Producto Partner Editado': 'Edited Partner Product',
    'Añadir Producto Partner': 'Add Partner Product',
    'Producto Partner Agregado': 'Added Partner Product',
    Dispositivo: 'Device',
    Editar: 'Edit',
    Detalle: 'Detail',
    'Editar Partner': 'Edit Partner',
    Proveedores: 'Providers',
    'Proveedor Partner Agregado': 'Partner Partner Added',
    'Proveedor Partner Editado': 'Edited Partner Provider',
    Imagen: 'Image',
    'Imagen URL': 'Image URL',
    'ID Externo': 'External ID',
    Visible: 'Visible',
    'Producto Id': 'Product Id',
    'Editar Producto': 'Edit Product',
    'Añadir Producto': 'Add Product',
    Abreviado: 'Abbreviated',
    'Proveedor Id': 'Provider Id',
    Ambos: 'Both',
    'ID Usuario': 'User ID',
    'Usuario (Correo electrónico)': 'User (Email)',
    Apellido: 'Surname',
    Documento: 'Document',
    'Estado de Registro': 'Registration Status',
    Rechazado: 'Rejected',
    Bloqueado: 'Blocked',
    'Fecha de ultimo login': 'Last login date',
    'Codigo Promocional': 'Promotional Code',
    'Desea activar registro?': 'Do you want to activate registration?',
    'Activar registro': 'Activate registration',
    'Ocurrio un error, comuniquese con soporte': 'An error occurred, contact support',
    'No puedes activar un registro ya actualizado.': 'You cannot activate an already updated record',
    'Desea rechazar registro?': ' you want to decline registration?',
    'Rechazar registro': 'Reject registration',
    Error: 'Error',
    '¡Error!': '¡Error!',
    'Medio de Registro': 'Registration Method',
    'Sub Categoría': 'Sub Category',
    'Fecha final de la autoexclusión': 'End date of self-exclusion',
    'Usuario Creación': 'Creation User',
    'Usuario Modificó': 'User Modified',
    Juego: 'Game',
    'Tipo saldo': 'Balance type',
    'Saldo recargas': 'Recharge balance',
    'Saldo retiros': 'Withdrawals balance',
    Detalles: 'Details',
    Historial: 'History',
    None: 'None',
    Cancelado: 'Canceled',
    'Añadir Ajuste': 'Add Setting',
    'Nombre Usuario': 'User Name',
    Movimiento: 'Movement',
    Entrada: 'Entry',
    Salida: 'Output',
    Cancelación: 'Cancellation',
    Valor: 'Amount',
    Respuesta: 'Answer',
    Abierto: 'Open',
    Cerrado: 'Closed',
    'Detalles del Ticket': 'Ticket Details',
    'Ticket Det Id': 'Ticket Det Id',
    'Ticket ID': 'Ticket ID',
    Market: 'Market',
    Fecha: 'Date',
    'Transacción ID': 'Transaction ID',
    Monto: 'Amount',
    'Historial de Transacciones': 'Transaction History',
    Usuario: 'User',
    Premios: 'Winnings',
    Pendiente: 'Pending',
    Redimido: 'Redeemed',
    Expirado: 'Expired',
    Libre: 'Free',
    Deposito: 'Deposit',
    'No Deposito': 'No Deposit',
    'Partner Bono Id': 'Partner Bonus Id',
    'Bono ID': 'ID Bonus',
    'ID Cliente': 'User ID',
    'Id Bono': 'Bonus ID',
    'Nombre de Bono': 'Bonus Name',
    'Fecha Aceptación': 'Acceptance Date',
    'Fecha Modificación': 'Modification Date',
    'Monto Convertido': 'Converted Amount',
    'Rollover Requerido': 'Rollover Required',
    Apostado: 'Bet',
    Restante: 'Remaining',
    'Fecha Expiración': 'Expiration Date',
    Apuestas: 'Bets',
    Ganancias: 'Earnings',
    'Premios Bonos': 'Bonus Winnings',
    'Beneficio %': 'Profit %',
    'Nombre Sistema Pasarela Pago': 'Payment Gateway System Name',
    Pagada: 'Paid',
    Rechazada: 'Rejected',
    Detallado: 'Detailed',
    Totales: 'Totals',
    'Resumen Financiero': 'Financial Summary',
    'Ajustar Saldo': 'Adjust Balance',
    'Usuario Id:': 'User Id:',
    'Tipo Saldo:': 'Balance Type:',
    'Monto:': 'Amount:',
    'Transacción Id': 'Transaction Id',
    Ganó: 'Won',
    Perdió: 'Lost',
    'No Acción': 'Void',
    'En Espera': 'Waiting',
    'Rechazada por Regla': 'Rejected by Rule',
    'Pendiente por pagar Punto de venta': 'Pending to pay - Betshop',
    'Retiro Voluntario': 'Cashout',
    'Dirección IP': 'IP Address',
    Odds: 'Odds',
    'Cambiar Contraseña': 'Change Password',
    Código: 'Code',
    'Generar Token': 'Generate Token',
    'Desbloquear Usuario por Clave': 'Unlock User by Password',
    Desbloquear: 'Unlock',
    'Ocurrio un error.': 'An error occurred.',
    'Cambios Realizados': 'Changes Made',
    'Estado de Usuario': 'User Status',
    'Estado de Contingencia': 'Contingency Status',
    'Contingencia Deportivas': 'Sports Contingency',
    'Contingencia Casino': 'Casino Contingency',
    'Contingencia Casino en Vivo': 'Live Casino Contingency',
    'Estado de Contingencia Virtuales': 'Virtual Contingency Status',
    'Estado de Contingencia Poker': 'Poker Contingency Status',
    'Estado de Registro del Usuario': 'User Registration Status',
    'Verificó DNI anterior': 'Verified front ID',
    'Verificó DNI posterior': 'Verified Back ID',
    'Nombre sistema de pago': 'Payment system name',
    'ID Cuenta': 'Account ID',
    Banco: 'Bank',
    'Número Cuenta Bancaria': 'Bank Account Number',
    'Código Interbancario': 'Interbank Code',
    'Tipo Cuenta': 'Account Type',
    Ahorros: 'Savings',
    Corriente: 'Current',
    'Cuenta Bancaria editada satisfactoriamente': 'Bank Account edited successfully',
    'Formas de Pago': 'Forms of Payment',
    Efectivo: 'Cash',
    'Cuenta Bancaria': 'Bank Account',
    'Giro Bancario': 'Bank Draft',
    'Punto de Venta': 'Bet Shop',
    Filtros: 'Filters',
    'Seguridad Cambios': 'Security Changes',
    Exportar: 'Export',
    'Cuentas Bancarias': 'Bank Accounts',
    'Total Depósitos': 'Total Deposits',
    'Total Apuestas Deportivas': 'Total Sports Betting',
    'Total Ganancias Deportivas': 'Total Sports Winnings',
    'Total Apuestas Casino': 'Total Casino Betting',
    'Ganancias Totales Casino': 'Total Casino Winnings',
    'Total Retiros': 'Total Withdrawals',
    'Total Ajustes Entrada': 'Total Entries Adjustments',
    'Total Ajustes Salida': 'Total Exits Adjustments',
    'Detalles Avanzados': 'Advanced Details',
    Guardado: 'Saved',
    'Error! ': 'Error! ',
    'Añadir Cuenta': 'Add Account',
    'Editar Cuenta': 'Edit Account',
    'Cuenta Actualizado': 'Account Updated',
    'Cuenta Agregado': 'Account Added',
    Encargado: 'Manager',
    'Añadir Área': 'Add Area',
    'Editar Área': 'Edit Área',
    'Área Actualizado': 'Updated Area',
    'Área Agregado': 'Added Area',
    'Datos no han podido ser cargados': 'Data could not be loaded',
    'Hora Inicio': 'Start Time',
    'Hora Cierre': 'Closing Time',
    'ID Plan de Cuentas': 'Account Plan ID',
    Referencia: 'Reference',
    'Añadir Concepto': 'Add Concept',
    'Plan de cuenta': 'Account plan',
    'Cuenta Id': 'Account Id',
    'Editar Concepto': 'Edit Concept',
    'Concepto Actualizado': 'Updated Concept',
    'Concepto Agregado': 'Added Concept',
    'Tipo de Centro': 'Type of Center',
    'Añadir Centro': 'Add Center',
    'Editar Centro': 'Edit Center',
    'Centro Actualizado': 'Updated Center',
    'Centro Agregado': 'Added Center',
    Área: 'Área',
    Cargo: 'Position',
    'Añadir Empleado': 'Add Employee',
    'Tipo Documento': 'Document Type',
    Cedula: 'Identification document',
    'Cedula de extrangería': 'Cedula de extrangería',
    Pasaporte: 'Passport',
    Salario: 'Salary',
    'Empleado Agregado': 'Added Employee',
    'Editar Empleado': 'Edit Employee',
    'Empleado Actualizado': 'Updated Employee',
    Consecutivo: 'Consecutive',
    'Tarjeta de crédito': 'Credit card',
    'Tipo de Egreso': 'Type de Egress',
    'Documento ID': 'Document ID',
    'Centro de Costos': 'Cost Center',
    Concepto: 'Concept',
    Creador: 'Creator',
    Impuesto: 'Tax',
    Retracción: 'Retraction',
    'Añadir Gasto': 'Add Expense',
    'Es punto de venta?': 'Is it a point of sale?',
    'Gasto Agregado': 'Added Expense',
    Factura: 'Invoice',
    'Editar Gasto': 'Edit Expense',
    'Gasto Actualizado': 'Updated Expense',
    'Tipo de Ingreso': 'Type of Income',
    Cuenta: 'Account',
    Soporte: 'Support',
    'Ingreso Agregado': 'Income Added',
    'Ingreso Actualizado': 'Income Updated',
    'Añadir Cargo': 'Add Charge',
    'Tipo Cargo': 'Type Charge',
    'Cargo Agregado': 'Added Charge',
    'Productos Internos?': 'Internal Products?',
    'Añadir Producto Tercero': 'Add Third Product',
    'Cuenta Contable Ingreso': 'Income Accounting Account',
    'Cuenta Contable Egreso': 'Accounting Account Egress',
    'Producto Interno?': 'Internal Product?',
    'Tipo Interno': 'Internal Type',
    'Plan cuentas Apuestas Tickets Tiendas': 'Plan accounts Betting Tickets BetShops',
    'Plan cuentas Premios Tickets Tiendas': 'Accounts BetShops Awards Account Plan',
    'Plan cuentas Pagos notas de retiro': 'Plan accounts Payments withdrawal notes',
    'Plan de cuentas Recargas': 'Deposit account plan',
    'Editar Producto Tercero': 'Edit Third Product',
    'Producto Tercero Agregado': 'Third Added Product',
    'Producto Tercero Actualizado': 'Updated Third Product',
    'Producto Terceros': 'Third Product',
    Añadir: 'Add',
    'Cuenta Contable': 'Accounting Account',
    Agregada: 'Added',
    'RUC - NIT': 'RUC - NIT',
    'Añadir Proveedor': 'Add Provider',
    'Proveedor Agregado': 'Added Provider',
    'Proveedor Actualizado': 'Updated Provider',
    'Valor Entradas': 'Entry Amount',
    'Valor Salidas': 'Output Amount',
    Nivel: 'Level',
    'Con Cajero': 'With Cashier',
    Centro: 'Center',
    'Añadir Tipo': 'Add Type',
    'Editar Tipo': 'Edit Type',
    'Tipo Actualizado': 'Updated Type',
    'Tipo Agregado': 'Added Type',
    'Plan de Cuentas': 'Account Plan',
    Areas: 'Areas',
    Empleados: 'Employees',
    'Reporte de cierre de día': 'Day closing report',
    Conceptos: 'Concepts',
    Egresos: 'Egress',
    'Reporte de Gastos': 'Expense Report',
    Ingresos: 'Income',
    'Otros Ingresos': 'Other Income',
    Cargos: 'Charges',
    'Producto Tercero': 'Third Product',
    'Producto Tercero Punto de Venta': 'Third BetShop Product',
    'Productos Terceros': 'Third Products',
    'Productos Terceros Punto de Venta': 'Third Products BetShop',
    'Reporte de Cuadre de día': 'Day Square Report',
    'Reporte de Cuadre de día 2': 'Day Square Report 2',
    Tipos: 'Types',
    'Añadir Tipos': 'Add Types',
    Afiliador: 'Affiliator',
    'No Procesado': 'Not Processed',
    'Añadir Agente': 'Add Agent',
    'Estado Validación': 'Validation Status',
    Región: 'Region',
    Departamento: 'Department / State',
    Ciudad: 'City',
    Modificado: 'Modified',
    '¿ Qué desea realizar ?': 'What do you want to do?',
    'Traslado a Saldo Recargas': 'Transfer to Deposit Balance',
    'Traslado a Saldo Juego': 'Transfer to Game Balance',
    'Transferir a saldo Recargas a ': 'Transfer to Deposit balance to ',
    Transferir: 'Transfer',
    'No Se ha realizado la transferencia. Comunicarse con soporte. ':
        'The transfer has not been made. Communicate with support.',
    'Se ha realizado la transferencia satisfactoriamente. ': 'The transfer was successful. ',
    'Transferir a Saldo Juego a ': 'Transfer to Game Balance to ',
    'Saldo Juego Actual': 'Current Game Balance',
    'Saldo Recargas Actual': 'Current Deposit Balance',
    'Saldo de Recargas': 'Saldo de Recargas',
    'Saldo de Juego': 'Game Balance',
    'Confirmar Valor': 'Confirm Value',
    Recargar: 'Deposit',
    'Los montos no coinciden': 'The amounts do not match',
    'Cupos Asignados': 'Assigned Quotas',
    'Historial cambios de cupo ': 'Change of quota history ',
    'Tipo Cupo': 'Quota Type',
    Recargas: 'Deposits',
    'Tipo Transacción': 'Transaction Type',
    'Asignado Por': 'Assigned By',
    'Comisión Nivel 1': 'Commission Level 1',
    'Comisión Nivel 2': 'Commission Level 2',
    'Comisión Nivel 3': 'Commission Level 3',
    'Comisión Nivel 4': 'Commission Level 4',
    'Comisión Punto': 'Commission Betshop',
    'Editar Comisión': 'Edit Commission',
    'Valores Editados': 'Edited Values',
    Mensual: 'Monthly',
    Diario: 'Daily',
    'Valor Base': 'Base Amount',
    Comision: 'Commission',
    'Valor Pagado': 'Paid Amount',
    'External ID': 'External ID',
    Pregunta: 'Question',
    'Saldo Afiliados': 'Affiliate Balance',
    'Desea pagar comisión en efectivo?': 'Do you want to pay commission in cash?',
    'Comisión Pagada': 'Commission Paid',
    'Desea abonar comisión a saldo recargas?': 'Do you want to pay commission to balance Deposit?',
    'Desea abonar comisión a saldo juego?': 'Do you want to pay commission to game balance?',
    'Desea abonar comisión a saldo afiliados?': ' you want to pay commission to affiliate balance?',
    'Desea Aprobar Comisión': 'You want to Approve Commission',
    'Aprobar Comisión': 'Approve Commission',
    'Comisión Aprobado': 'Commission Approved',
    'Restricción IP': 'IP Restriction',
    'Token Google': 'Google Token',
    'Token Local': 'Local Token',
    'No tienes un QR Configurado.': "You don't have a QR Set.",
    UserModifId: 'UserModifId',
    Comisiones: 'Commissions',
    'Apuestas Totales Liquidadas': 'Total Liquidated Bets',
    'Deporte Profitness': 'Profitness Sport',
    'Casino Profitness': 'Casino Profitness',
    'Reporte de Retiros': 'Withdrawal Report',
    'Tipo de Apuesta': 'Bet Type',
    'Apuestas Creadas': 'Bets Created',
    'Apuestas Cerradas': 'Closed Bets',
    'Apuestas Pagadas': 'Paid Bets',
    'Cantidad Tickets': 'Number of Tickets',
    Stake: 'Stake',
    'Stake Promedio': 'Average Stake',
    Payout: 'Payout',
    Bonos: 'Bonus',
    Bonos1: 'Bonus',
    'Fecha Creación': 'Creation Date',
    Pendientes: 'Pending',
    'Bono Deposito': 'Deposit Bonus',
    'Bono No Deposito': 'No Deposit Bonus',
    Freebet: 'Freebet',
    Presupuesto: 'Budget',
    Aprobado: 'Approved',
    'Responder Solicitud': 'Answer Request',
    'Respuesta Generada': 'Generated Response',
    'Envie una Respuesta': 'Send an Answer',
    'Aprobar Solicitud': 'Approve Request',
    'Rechazar Solicitud': 'Reject Request',
    Requisitos: 'Requirements',
    'Historial de requisitos enviados': 'History of submitted requirements',
    Requisito: 'Requirement',
    'Añadir Requisito': 'Add Requirement',
    'Tipo Usuario': 'Type User',
    'Editar Requisito': 'Edit Requirement',
    'Nombre:': 'Name:',
    'Tipo Usuario:': 'User Type:',
    'Requisito Editado': 'Requirement Edited',
    'Requisito Agregado': 'Requirement Added',
    'Estadisticas Marketing': 'Statistics Marketing',
    'Marketing Vs Registros': 'Marketing Vs Records',
    'Top Usuarios': 'Top Users',
    Clave: 'Key',
    'Datos Configuración': 'Data Configuration',
    'Reporte de Bonos': 'Bonus Report',
    'Reporte de Casino': 'Online Games Report', // Titulo Seccion
    'Reporte de Comisiones': 'Report of Commissions',
    'Reporte de Comisiones Detallado': 'Commission report Detailed',
    'QR Google': 'QR Google',
    'Reporte de Depósitos': 'Deposits report',
    'Flujo de Caja': 'Cash flow',
    'Reporte de Flujo de Caja': 'Report of Cash Flow',
    'Flujo de caja hijos': 'Cash flow children',
    'Reporte de Flujo de Caja Hijos': 'Report of Cash Flow Children',
    'Reporte de Apuestas': 'Bets Report',
    'Flujo Caja Hijos': 'Cash Flows Children',
    'Usuarios Afiliados': 'Affiliate Users',
    Marketing: 'Marketing',
    Informe: 'Report',
    'Códigos Promocionales': 'Promotional Codes',
    'Solicitudes de Agentes': 'Applications of Agents',
    'Ultimos 3 días': 'Last 3 days',
    'Ultimos 7 días': 'Last 7 days',
    'Añadir Punto': 'Add A BetShop',
    Login: 'Login',
    'Apuesta Total': 'Total Bet',
    Latitud: 'Latitude',
    Longitud: 'Length',
    'Punto de venta Agregado': 'BetShop Added',
    'Editar Punto': 'Edit BetShop',
    Competencia: 'Competition',
    'Punto de venta Actualizado': 'BetShop Updated',
    'Publicidad Punto': 'Advertising BetShop',
    'Añadir Publicidad': 'Add Advertising',
    'Añadir Publicidad Cajero': 'Add Advertising Atm',
    Cajeros: 'Cashier',
    'Añadir Cajero': 'Add Cashier',
    Ruta: 'Route',
    'Publicidad Añadida': 'Advertising Added',
    'Editar Publicidad': 'Edit Advertising',
    'Publicidad Actualizada': 'Advertising Up-To-Date',
    'Publicidad Cajero Añadida': 'Advertising Cash Added',
    'Editar Publicidad Cajero': 'Edit Advertising Atm',
    'Abrir Publicidad': 'Open Advertising',
    'Computador ID': 'Computer ID',
    'Min Apuesta': 'Min Bet',
    'Max Apuesta Live': 'Max Bet Live',
    'Max Apuesta PreMatch': 'Max Bet PreMatch',
    'Cajero Agregado': 'Atm Added',
    'Comisión Usuario': 'Commission User',
    'por Abuelo': 'by Grandfather',
    'por Padre': 'by Father',
    'por Hijo': 'by Son',
    'por Nieto': 'by Grandson',
    Total: 'Total',
    'Total:': 'Total:',
    'Usuario REF': 'User REF',
    'Fecha de Creación': 'Creation Date',
    'Pregunta ': 'Question ',
    'Seleccione el tipo de saldo ': 'Select the type of balance ',
    'Saldo Recarga': 'Balance Recharge',
    'Ganancias sujetas a impuestos': 'Earnings subject to tax',
    'Valor Apostado': 'Bet Amount',
    'Valor Premio': 'Winnings Amount',
    Ganancia: 'Gain',
    'La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ':
        'The password must contain minimum 6 characters and a number, a character cannot be repeated more than 3 times consecutively ',
    'Fecha ultima detección': 'Date last detection',
    Plataforma: 'Platform',
    'Nombre Archivo': 'File Name',
    'Hash Original': 'Original Hash',
    'Hash Detectado': 'Hash Detected',
    'Fecha modificación': 'Modification date',
    'Reporte de Hash': 'Report Hash',
    Tecnología: 'Technology',
    Financiero: 'Financial',
    'Filtrar Tabla': 'Filter Table',
    'Dirigido al Departamento': 'Addressed to the Department',
    'Título de la petición': 'Title of the request',
    Título: 'Title',
    'Generar Petición': 'Generate Request',
    Generar: 'Generate',
    'Añadir Respuesta': 'Add Reply',
    'Respuestas de la petición': 'Responses to the request',
    'La petición debe estar activa': 'The request must be active',
    Acción: 'Action',
    'Usuario Creo': 'Created by',
    'Desea cerrar la petición?': 'You want to close the petition?',
    'Cerrar Peticíon': 'Close Peticíon',
    'Estado de petición actualizada': 'Status of request is updated',
    'Desea Activar la petición?': 'You want to Enable the request?',
    'Activar Peticíon': 'Activate Peticíon',
    'Responder Petición': 'Respond To Request',
    Peticiones: 'Requests',
    'Mensaje Id': 'Message Id',
    Casino: 'Casino',
    'Live Casino': 'Live Casino',
    'Añadir Mensaje': 'Add Message',
    'Editar Mensaje': 'Edit Message',
    Mensaje: 'Message',
    Asunto: 'Issue',
    Emisor: 'Issuer',
    Receptor: 'Receiver',
    Leido: 'Read',
    Mensajes: 'Messages',
    'Tipo de Producto': 'Product type',
    'Fecha Inicio': 'Start Date',
    'Fecha Fin': 'End Date',
    'Añadir Liga': 'Add League',
    Resultados: 'Results',
    'Fecha del ultimo logueo': 'Date of last login',
    'Reporte de Apuestas Deportivas': 'Report of Sports Betting',
    Usuarios: 'Users',
    'Tabla de Resultados': 'Table of Results',
    Nro: 'Nro',
    Puntuación: 'Score',
    'Saldo Actual de usuarios por Edades': 'Current balance of users by Age',
    Deportivo: 'Sports',
    Si: 'Yes',
    'Liga Agregada Correctamente': 'League Added Correctly',
    'La Fecha de inicio debe ser menor a la fecha fin.': 'The start Date must be less than the end date.',
    'Añadir Liga:': 'Add League:',
    'Segundo Nombre': 'Second name',
    Notificaciones: 'Notifications',
    'Lista de Ligas': 'List of Leagues',
    Información: 'Information',
    Reportes: 'Reports',
    Configuración: 'Settings',
    'Reporte de Usuarios': 'Reporting Users',
    'Publicidad Máquina': 'Advertising Machine',
    'Id Nota de Retiro': 'Withdrawal note ID',
    'Valor a pagar': 'Value to pay',
    'Premio Proyectado': 'Potential Winnings',
    Ganador: 'Winner',
    'Pagar Nota Retiro': 'Pay Note Retirement',
    'No. Ticket': 'Bet ID',
    'Clave Ticket': 'IB Number',
    'Pagar Premio': 'Pay Award',
    Encendida: 'On',
    Apagada: 'Off',
    'Usuario Actualizó': 'User Has Updated',
    'Reporte de Logs': 'Report Logs',
    'Reporte de Actualizaciones': 'Report Updates',
    'Actualizar Versión ': 'Update Version ',
    Vinculo: 'Link',
    Actualizar: 'Update',
    'Actualizar Ambos ': 'Update Both ',
    'Enviar Comando a ': 'Send Command to ',
    Enviar: 'Send',
    'Tipo Establecimiento': 'Type Of Establishment',
    Versión: 'Version',
    'Documento 1': 'Document 1',
    'Documento 2': 'Document 2',
    'Añadir Traducción': 'Add Translation',
    'Traducción Agregada': 'Translation Added',
    'Editar Traducción': 'Edit Translation',
    'Traducción Editada': 'Edited Translation',
    'Obtener URL': 'Get the URL',
    'Subir Imagen': 'Upload Image',
    'Primer nombre': 'First name',
    'CashDesk Name': 'CashDesk Name',
    Hora: 'Time',
    'Usuario que lo creo': "User that's what I think",
    'Tipo:': 'Type:',
    'Descripción:': 'Description:',
    'Valor:': 'Value:',
    'Ingreso por tarjeta de crédito añadido satisfactoriamente': 'Income per credit card added successfully',
    'Seleccione tipo de factura': 'Select type of invoice',
    POS: 'POS',
    CARTA: 'LETTER',
    'Nro. Documento': 'Nro. Document',
    'Proveedor Tercero': 'Third-Party Vendor',
    'Concepto:': 'Concept:',
    'Nro. Documento:': 'Nro. Document:',
    'Proveedores Terceros': 'Third Party Suppliers',
    'Error, comuniquese con soporte. ': 'Error, contact support. ',
    'Egreso añadido satisfactoriamente': 'Exit added successfully',
    'Proveedor Tercero:': 'Third Party Supplier:',
    'Ingreso añadido satisfactoriamente': 'Entry added successfully',
    'Dinero Inicial:': 'Initial Money:',
    'Total Ingresos:': 'Total Income:',
    'Total Egresos:': 'Total Expenditures:',
    'Ingresos Tarjeta Credito:': 'Income Card Credit:',
    'Verifique que todos los datos sean validos ': 'Verify that all data are valid ',
    'Forma Pago 1': 'Payment method 1',
    'Pago Bono \/ T.C.': 'Payment Bond \/ T. C.',
    'Valor Entradas Efectivo': 'Value Cash',
    'Valor Entradas Bono \/ T.C.': 'Amount on Bonus Entry',
    'Valor Entradas Traslados': 'Amount on Transfers Entry',
    'Valor Entradas Recargas': 'Top-ups Entry amount',
    'Valor Salidas Efectivo': 'Value Outputs Cash',
    'Valor Salidas Traslados': 'Value Outputs Transfers',
    'Valor Salidas Notas de Retiro': 'Withdrawal Notes Output',
    'V.Entradas Efectivo': 'Cash gross sales',
    'V.Entradas Efectivo Neto': 'Cash Net sales',
    'V.Entradas Bono/T.C': 'Value Entries Bonus \/ T. C.',
    'V.Entradas Traslados': 'Value Inputs Transfers',
    'V.Entradas Recargas': 'Top-ups Entry amount',
    'V.Salidas Efectivo': 'Cash gross Payouts',
    'V.Salidas Efectivo Neto': 'Cash Net Payout',
    'V.Salidas Traslados': 'Value Outputs Transfers',
    'V.Salidas N.Retiro': 'Withdrawals Notes output',
    Saldo: 'Balance',
    'Pagada?': 'Paid?',
    'Numero del cliente:': 'User ID:',
    'Cedula del cliente:': 'User identity document:',
    'Email del cliente:': 'User E-mail:',
    'Campo No Valido': 'Field Is Not Valid',
    'Filtre Mínimo por un campo': 'Filter Minimum for a field',
    'Nro. de Cliente:': 'Nro. Client:',
    'Nombre del Cliente:': 'Name of the Client:',
    'País:': 'Country:',
    'Moneda:': 'Currency:',
    'Valor a Recargar:': 'Value to Reload:',
    'Desea Realizar la Recarga?': 'You want to Perform the Recharge?',
    'Ocurrio un error...': 'It occured an error...',
    'Recarga Completada Satisfactoriamente': 'Reload Completed Successfully',
    'Añadir Competidor': 'Add Competitor',
    Competidores: 'Competitors',
    'Competidor Agregado': 'Competitor Added',
    'Editar Competidor': 'Edit Competitor',
    'Competidor Editado': 'Competitor Released',
    'Fecha de creación:': 'Creation date:',
    'Nombre de Usuario:': 'User name:',
    'Valor de la nota:': 'Value of the note:',
    'Eliminar Nota': 'Delete Note',
    'ID Nota de Retiro:': 'ID Note of Retreat:',
    'Observaciones:': 'Observations:',
    'Nro Nota Retiro:': 'Nro Note Retirement:',
    'Nro Usuario:': 'Nro User:',
    'Fecha Eliminación': 'Date Removal',
    'Nombre del Usuario:': 'User name:',
    'Usuario que la Eliminó:': 'User that Removed it:',
    'Fecha Nota': 'Date Note',
    'Nro Nota Retiro': 'Nro Note Retirement',
    'Valor Nota': 'Value Note',
    Observaciones: 'Comments',
    'Historial de gestiones': 'History of efforts',
    'Fecha\/hora': 'Date\/time',
    Texto: 'Text',
    'Nota Generada': 'Note Generated',
    'Nombres:': 'Names:',
    'Apellidos:': 'Surname:',
    'Teléfono:': 'Phone:',
    'Skype:': 'Skype:',
    'Dirección:': 'Address:',
    'Email:': 'Email:',
    'Empresa:': 'Company:',
    Empresa: 'Company',
    Provincia: 'Province',
    Observacion: 'Observation',
    'Fecha\/Hora Ultima Modif': 'Date\/Time Of Last Modif',
    'Usuario Ultima Modif': 'User Last Modif',
    'Desea Terminar Gestión?': 'You Want To Finish Management?',
    'Terminar Gestión': 'End Management',
    'Gestión Terminada satisfactoriamente. ': 'Management Completed successfully. ',
    'Cedula de Ciudadania': 'Cedula de Ciudadania',
    'Cedula de Extranjeria': 'Cedula de Extranjeria',
    'Primer Nombre:': 'First Name:',
    'Primer Nombre': 'First Name',
    'Nro Documento:': 'ID Number:',
    'Nro Documento': 'ID Number',
    'Segundo Nombre:': 'Second Name:',
    'Segundo Nombre': 'Second Name',
    'Primer Apellido:': 'First Surname:',
    'Primer Apellido': 'First Surname',
    'Segundo Apellido:': 'Second Surname:',
    'Segundo Apellido': 'Second Surname',
    'Nro Cheque:': 'Ticket Number:',
    'Nro Cheque': 'Ticket Number',
    Origen: 'Source',
    'Nota Retiro': 'Withrawal Note',
    Ticket: 'Ticket',
    'Cliente:': 'Client:',
    Cliente: 'Client',
    'Documento Referente:': 'Document Reference:',
    'Documento Referente': 'Document Relating To',
    'Doc. Cliente:': 'Doc. Client:',
    'Doc. Cliente': 'Doc. Client',
    'Nro. Recarga:': 'Nro. Recharge:',
    'Nro. Recarga': 'Nro. Recharge',
    'Nro. Cliente:': 'Nro. Client:',
    'Nro. Cliente': 'Nro. Client',
    'Nombre Cliente:': 'Name Client:',
    'Nombre Cliente': 'Name Client',
    'Usuario Solicita': 'User Requests',
    Campo: 'Field',
    Antiguo: 'Old',
    Nuevo: 'New',
    Aprobadas: 'Approved',
    Rechazadas: 'Rejected',
    'Desea Rechazar el log?': 'You want to Reject the log?',
    'Rechazar log': 'Reject log',
    'Estado de log actualizado': 'Status log updated',
    'Desea Aprobar el log?': 'You want to Pass the log?',
    UserName: 'UserName',
    Listo: 'Ready',
    Aprobada: 'Approved',
    'Tipo de usuario': 'Type of user',
    'Administrador General': 'General Manager',
    'Administrador Secundario': 'Secondary Administrator',
    Operador: 'Operator',
    'System Administrator': 'System Administrator',
    Consultas: 'Queries',
    'ADMIN AFILIADOS': 'ADMIN AFFILIATES',
    CUSTOM: 'CUSTOM',
    'Usuario de País': 'User Country',
    'Categoría cliente': 'Category client',
    'Añadir Usuario': 'Add User',
    'Numero de Documento': 'Number of Document',
    Género: 'Gender',
    Cumpleaños: 'Birthday',
    'Está bloqueado?': 'Is locked?',
    'País Residencia': 'Country Residence',
    'Provincia\/Región Residencia': 'Province\/Region Residence',
    'Ciudad Residencia': 'City Residence',
    'Código Zip': 'Zip Code',
    Celular: 'Phone Number',
    'Fecha de registro': 'Date of registration',
    Perfil: 'Profile',
    Página: 'Page',
    DíasCaducidadClave: 'DaysExpirationKey',
    'Menus no permitidos': 'Menus are not allowed',
    'Menus Permitidos': 'Menus Allowed',
    ADMIN: 'ADMIN',
    ADMIN2: 'ADMIN2',
    'ADMIN AGGREGATOR': 'ADMIN AGGREGATOR',
    CAJERO: 'ATM',
    CONCESIONARIO: 'DEALER',
    CONCESIONARIO2: 'CONCESIONARIO2',
    OPERADOR: 'OPERATOR',
    PUNTOVENTA: 'PUNTOVENTA',
    CONSULTAS: 'QUERIES',
    ADMINAFILIADOS: 'ADMINAFILIADOS',
    'Debe de seleccionar un usuario.': 'You must select a user.',
    Menu: 'Menu',
    Submenu: 'Submenu',
    Adicionar: 'Add',
    'Cedula Nacional': 'Schedule National',
    'Cedula Extranjera': 'Schedule A Foreign',
    Trabajador: 'Worker',
    'Familiar Trabajador': 'Family Worker',
    'Añadir Usuario a Bloquear': 'Add User to Block',
    'Usuario Asociado': 'User Associated',
    Regional: 'Regional',
    'Tipo Punto': 'Type BetShop',
    Partners: 'Partner',
    'Recargar Credito': 'Deposit',

    'Torneos y Bonos': 'Tournaments and Bonuses',
    'Mi Configuracion': 'Settings',
    'Partners Proveedores': 'Provider Partners',
    'Partners Tipo Producto': 'Partners Type',
    'Partners Productos': 'Partners Products',
    'Partners Productos Pais': 'Partners Products Country',
    Categorias: 'Categories',
    'Categorías Productos': 'Product Categories',
    Jugadores: 'Players',
    'Jugadores Partner': 'Players Partner',
    'Jugadores Aggregator': 'Players Aggregator',
    'Reporte de depósitos': 'Deposits Report',
    'Autoexclusiones de Usuario': 'Self-excluded users',
    'Reporte de casino': 'Online Games Report', // Menu Lateral
    'Reporte de Saldos': 'Balance Report',
    'Reporte de bonos': 'Bonus Report',
    'Reporte de Jugadores': 'Report Players',
    'Flujo de Caja Histórico': 'Cash flow Historical',
    'Flujo de Caja Resumido': 'Cash flow Summary',
    'Informe Gerencial': 'Management Report',
    'Usuario online Resumido': 'Online Users Summary',
    'Usuario - Agregator': 'User - Agregator',
    'Premios pendientes por pagar': 'Awards Outstanding Payment',
    'Reporte de Sesiones': 'Report of Sessions',
    'Reporte de Ajustes de Saldos': 'Adjustment of Balances Report',
    'Reporte Trans. Sportbook': 'Report Trans. Sportbook',
    'Reporte de  Movimientos Saldo': 'Movement of Balances Report',
    'Historico de  Saldos': 'Balance Record',
    'Documentos Registrados': 'Recorded Documents',
    Contabilidad: 'Accounting',
    'Centros de costo': 'Cost centers',
    Estructural: 'Structural',
    Cuentas: 'Accounts',
    'Cierres de Caja': 'Close of CashBox',
    Seguridad: 'Security',
    'Aprobar logs': 'Approve logs',
    'Usuarios administrativos': 'Administrative users',
    'Usuarios Bloqueados': 'Blocked Users',
    Contingencia: 'Contingency',
    Menus: 'Menus',
    Perfiles: 'Profiles',
    'Perfiles - Options': 'Profiles - Options',
    'Sub Menu': 'Sub Menu',
    'Usuario Perfil': 'User Profile',
    Gestion: 'Management',
    'Codigos Promocionales': 'Promotional Codes',
    'Activar Registros': 'Activate Records',
    'Ajustar pasarela de pago': 'Adjust payment gateway',
    'Asignacion de cupo': 'Allocation of quota',
    'Eliminar nota de retiro': 'Delete note retirement',
    'Manejar red': 'Manage network',
    'Registro rapido': 'Quick registration',
    'Reimprimir cheque': 'Reprint Ticket',
    Reversion: 'Reversal',
    'Trabaja con nosotros': 'Work with us',
    Caja: 'CashBox',
    'Pago Premio': 'Prize payment',
    'Pago Nota Retiro': 'Withdrawal notes payment',
    Lista: 'List',
    Maquinas: 'Machines',
    Registrar: 'Register',
    'Pago Nota de cobro': 'Payment Note collection',
    'Maquinas Grafica': 'Machines Chart',
    Herramientas: 'Tools',
    'Partner Ajustes': 'Partner Settings',
    Traducción: 'Translation',
    'Subir imagen': 'Upload Image',
    'Gestión Punto de Venta': 'Bet Shop Management',
    'Gestión Puntos Gráfico': 'Bet Shop Management Chart',
    'Puntos de venta Competencia': 'Bet Shops Competition',
    Agentes: 'Agents',
    'Lista de Agentes': 'List of Agents',
    'Árbol de Agentes': 'Agents Tree',
    'Informe de Agentes': 'Report of Agents',
    Transferencias: 'Transfers',
    Solicitudes: 'Applications',
    'Solicitudes de Retiro': 'Withdrawal Requests',
    'Solicitudes de Deposito': 'Deposit Requests',
    'Cierre de caja': 'Closing cash',

    'Inicio Día': 'Begin Day',
    'Fecha: ': 'Date: ',
    'Valor Inicio de día:': 'Amount Begin Day',

    'Agregar imagen': 'Add image',
    'Añadir Proveedor Partner': 'Add Partner provider',
    'Proveedor Partner': 'Partner provider',
    'Tipo Producto Partner': 'Type Product Partner',
    'Saldo Depósitos:': 'Balance Deposit:',
    'Tipo de integración': 'Type of integration',
    'Pasarela de Pagos': 'Payment gateway',
    'Lobby con token propio': 'Lobby with own token',
    'Lobby con token de proveedor': 'Lobby with provider token',
    'Productos Partner': 'Partner Products',
    Automático: 'Automatic',
    'Partners Productos País': 'Partners Products Country',
    'Lista de Jugadores': 'Player List',
    Bloqueados: 'Blocked',
    'DNI Anterior': 'Previous DNI',
    'No tiene DNI Anterior': 'You do not have a previous DNI',
    'DNI Posterior': 'Later DNI',
    'No tiene DNI Posterior': 'You do not have a later DNI',
    Descargar: 'Download',
    'Tipo de Documento': 'Document type',
    'Cedula de Extranjería': 'Foreigner ID',
    'Subir DNI Anterior': 'Front ID',
    'Subir DNI Posterior': 'Back ID',
    Finanzas: 'Finance',
    Resumen: 'Summary',
    'Reporte Autoexclusión': 'Self-exclusion Report',
    'Reporte de Sesiones': 'Session Report',
    'Registro de Documentos': 'Document Registration',
    'Ver más': 'See more',
    'Historial de saldo': 'Balance Record',
    'Historial de movimientos': 'Movement History',
    'Logs Usuario': 'User Logs',
    'Valor Mínimo': 'Minimum Amount',
    'Valor Máximo': 'Maximum Amount',
    'Premio Total Máximo': 'Maximum Total Award',
    'Premio Total Mínimo': 'Minimum Total Award',
    'Crear Token Personalizado': 'Create Custom Token',
    'Crear Token': 'Create Token',
    Token: 'Token',
    'Token Creado': 'Token Created',
    'Cancelar Cuenta': 'Cancel Account',
    'Desea cancelar la cuenta de el usuario?': "Do you want to cancel the user's account?",
    'Resumen por Proveedor': 'Summary by provider',
    'Tipo Pasarela de Pago': 'Payment Gateway Type',
    'Proveedor pasarela de pago': 'Provider payment gateway',
    'Usuarios Autoexcluidos': 'Self-excluded Users',
    Cantidad: 'Quantity',
    'Saldo Gratis': 'Free Balance',
    Envió: 'Sending',
    'Reporte de Saldos Online': 'Online Balance Report',
    'Añadir bono a saldo': 'Add bonus to balance',
    'Bono a saldo añadido correctamente': 'Balance bonus added successfully',
    'Tipo de Detalle': 'Type of Detail',
    Apuesta: 'Bet',
    'Apuesta Promedio': 'Average Bet',
    'Usuarios Registrados': 'Registered users',
    'Primeros Depósitos': 'First Deposits',
    'Usuario Id': 'User Id',
    'Cant Tickets Casino': 'Number of Casino Tickets',
    'Cant Tickets Casino Vivo': 'Number of Live Casino Tickets',
    'Total Tickets': 'Total Tickets',
    'Saldo Disp Retiro': 'Available Balance Withdrawal',
    'Nota de retiro pendiente': 'Pending Withdrawal Note',
    'Vlr Ap. Casino': 'Amount Bet on Casino',
    'Vlr Ap. Casino Vivo': 'Amount Bet on Live Casino',
    'Total Apostado': 'Total Bet',
    'Vlr Pr. Casino': 'Casino Winnings Amount',
    'Vlr Pr. Casino Vivo': 'Live Casino Winnings Amount',
    'Total premios': 'Total Prize',
    'Saldo Recargas': 'Balance Recharges',
    'Valor Recargas': 'Top-Ups Amount',
    'Valor premios': 'Winnings Amount',
    'Relación Usuario Aggregato': 'Aggregato User Relation',
    'Usuario Partner': 'User Partner',
    'Usuario Aggregator': 'User Aggregator',
    'Añadir Relación': 'Add Relation',
    'Editar Relación': 'Edit Relation',
    'Hora de creación': 'Creation time',
    'Fecha Premio': 'Prize Date',
    'Hora Premio': 'Prize Time',
    'Transacciones deportivas': 'Sportbook transactions',
    'Saldo Inicial': 'Initial Balance',
    'Ap. Deportivas': 'Sportbook bets',
    'Pr. Deportivas': 'Sportsbook Winnings',
    'Ap. Casino': 'Bet Casino',
    'Pr. Casino': 'Prize Casino',
    'Retiros Creados': 'Withdrawals Created',
    'Retiros Eliminados': 'Withdrawals Eliminated',
    'Ajustes E': 'Settings E',
    'Ajustes S': 'Settings S',
    'Saldo Final': 'Final Balance',
    'Saldo Final Calc.': 'Final Balance Calculated',
    'Retiros Pagados': 'Withdrawals Paid',
    'Retiros Pendientes': 'Pending Withdrawals',
    'Bonos Free Ganados': 'Free Bonuses Won',
    'Añadir Documento': 'Add Document',
    'Editar Documento': 'Edit Document',
    'Puntos de Venta': 'Betshop',
    'Saldo Juego': 'Balance Game',
    'Datos Punto de venta': 'Data Point of Sale',
    'Configuración Punto de Venta': 'Point of Sale Configuration',
    Contraseña: 'Password',
    'Forma de pago': 'Transfered To',
    Modificó: 'Modified',
    'Nombre del sistema de pasarela de pago': 'Payment Gateway System Name',
    'Tipo de tiempo': 'Type of time',
    Resultado: 'Results',
    'Fecha Resultado': 'Date Results',
    'Reporte Flujo de Caja': 'Cash Flow Report',
    'Rollover Apostado': 'Betting Rollover',
    'Rollover Restante': 'Remaining Rollover',
    'Estado de Recarga': 'Recharge Status',
    'Actualizar IP': 'Update IP',
    'Punto de Venta:': 'BetShop:',
    'ID Sesión': 'Session ID',
    'Tipo de Cierre': 'Clasp type',
    Sistema: 'System',
    'Hora Fin': 'End Time',
    Geolocalización: 'Geolocation',
    'Monto Apostado': 'Bet Amount',
    'Créditos Promocionales Recibidos': 'Promotional Credits Received',
    'Créditos Promocionales Apostados': 'Promotional Credits Bet',
    'Motivo Cierre': 'Reason Close',
    'Saldo al Iniciar': 'Start Balance',
    'Saldo al Final': 'Balance at the end',
    'Monto Ganado': 'Amount Earned',
    'Sistema operativo': 'OS',
    'Inicio de sesión fallidos': 'Login failed',
    'Cambio realizado a la cuenta': 'Change made to the account',
    'Cuenta cancelada': 'Canceled account',
    'Arrastra Negativos': 'Drag Negatives',
    Estadísticas: 'Statistics',
    Estadisticas: 'Statistics',
    Sí: 'Yes',
    'Añadir Agente:': 'Add Agent:',
    Eliminado: 'Removed',
    Devueltas: 'Returned',
    'Añadir Código': 'Add Code',
    'Editar Código': 'Edit Code',
    'Visitas Links': 'Visits Links',
    Registros: 'Logs',
    Edad: 'Age',
    'Informe Red': 'Network Report',
    'Realizar Transferencia': 'Make Transfer',
    Apellidos: 'Surnames',
    'Productos Terceros ': 'Third Products',
    'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.':
        'The password must contain at least 8 characters, a lowercase, an uppercase and a number.',
    Depositos: 'Deposits',
    'JUGADORES ACTIVOS': 'ACTIVE PLAYERS',
    APUESTAS: 'BETS',
    'PREMIOS PAGADOS': 'PRIZES PAID',
    'Aprobación Logs': 'Logs Approval',
    'Aprobar log': 'Approve log',
    'Administración de Usuarios': 'User administration',
    'Administración de Usuarios Bloqueados': 'Administration of Blocked Users',
    'Usuario:': 'User:',
    'Usuario es de País': 'User is from Country',
    'Usuario es Global': 'User is Global',
    'Activar Usuario País': 'Activate User Country',
    'Inactivar Usuario País': 'Inactivate User Country',
    'Añadir Usuario:': 'Add User:',
    'Perfil Opciones': 'Profile Options',
    'Códigos promocionales': 'Promotional Codes',
    Función: 'Function',
    Registro: 'Registry',
    'Activar Registro': 'Activate Registration',
    'Gestión Contacto': 'Contact Management',
    'Fecha/Hora Creación': 'Creation Date / Time',
    Nombres: 'Names',
    'Crear Nota': 'Create Note',
    Terminado: 'Finished',
    'Flujo Caja': 'Cash Flow',
    'Pago Nota de Retiro': 'Payment Withdrawal Note',
    Máquinas: 'Machines',
    'Añadir Máquina': 'Add Machine',
    'Añadir Máquina:': 'Add Machine:',
    'Teléfono Mobile': 'Mobile Phone',
    'Recargar Máquina ': 'Reload machine ',
    'Actualizar Máquina': 'Update Machine',
    'Actualizar Versión': 'Update Version',
    'Actualizar Máquina ': 'Update Machine ',
    Publicidad: 'Advertising',
    'Fecha última entrada': 'Last Entry Date',
    'Estado de Máquina': 'Machine state',
    'Pago Nota de Cobro': 'Payment Note collection',
    'Máquinas Grafica': 'Graphic Machines',
    General: 'General',
    'Solicitud de retiro de clientes': 'Customer Withdrawal Request',
    'Solicitud de depósito de clientes': 'Customer Deposit Request',
    'Ajustes Generales': 'General adjustments',
    'Nombre Compañía': 'Company name',
    'Días de expiración de la contraseña': 'Password Expiration Days',
    'Regular Expresión contraseña usuario': 'Regular User password expression',
    'Días de expiración contraseña temporal': 'Days of expiration of temporary password',
    'Mínima longitud de la contraseña': 'Minimum password length',
    'Días antes de notificación de expiración': 'Days before expiration notification',
    'Expresión regular que valide una contraseña. ': 'Regular expression that validates a password. ',
    'Ej: Que tenga entre 4 y 16 caracteres.': 'Ex: That has between 4 and 16 characters.',

    'Cuantos días antes de que expire la contraseña, se le notificara el cambio':
        'How many days before the password expires, you will be notified of the change',
    'Máximo solicitudes por día': 'Maximum requests per day',
    'Porcentaje mínimo apostado/depositado': 'Minimum percentage wagered / deposited',
    'Porcentaje mínimo apostado sobre lo depositado': 'Minimum percentage wagered on deposited',
    'Especifique el porcentaje mínimo apostado sobre lo depositado.':
        'Specify the minimum percentage wagered on the deposit.',
    'Mínimo monto en solicitud de retiro': 'Minimum amount in withdrawal request',
    'Máximo monto en solicitud de retiro': 'Maximum amount in withdrawal request',
    'Máxima cantidad de solicitudes activas': 'Maximum number of active requests',
    'Mínimo monto de solicitud de deposito': 'Minimum deposit request amount',
    'Máximo monto de solicitud de deposito': 'Maximum deposit request amount',
    'Impuesto Retiro Saldo Deposito': 'Tax Withdrawal Balance Deposit',
    'Impuesto Retiro Saldo Premios a partir de': 'Withdrawal Tax Balance Awards from',
    'Impuesto por Retiro Saldo Premios a partir de un valor.': 'Withdrawal Tax Balance Prizes from a security.',
    'Aprobar cuentas bancarias?': 'Approve bank accounts?',
    'Porcentaje Penalidad Retiro Saldo Retiros': 'Percentage Penalty Withdrawal Balance Withdrawals',
    'Especifique el porcentaje de la penalidad por retiro a saldo de retiros.':
        'Specify the percentage of the penalty for withdrawal to balance of withdrawals.',
    'Días para alerta de actualización de datos': 'Days for data update alert',
    'Días para alerta de actualización de datos del usuario.': 'Days for user data update alert.',
    'Impuesto Retiro Saldo Premios': 'Tax Withdrawal Balance Awards',
    'Impuesto al ente regulador a partir de': 'Tax to the regulatory entity from',
    'Aprobar cambios de información personal?': 'Approve changes to personal information?',
    'Aprobar los cambios de información personal hechos por el usuario?':
        'Approve the changes of personal information made by the user?',
    'Mínimo Retiro de Saldo Retiros para Penalizar': 'Minimum Balance Withdrawal Withdrawals to Penalize',
    'Especifique el monto mínimo de retiro de saldo retiros para penalizar.':
        'Specify the minimum withdrawal amount of balance withdrawals to penalize.',
    'Días para alerta de cambio de contraseña': 'Days for password change alert',
    'Impuesto al ente regulador': 'Regulatory Entity Tax',
    'Impuesto premios por punto de venta físico': 'Tax awards per physical point of sale',
    'Impuesto a los premios reclamados por punto de venta físico': 'Tax on prizes claimed by physical point of sale',
    'Máximo cuentas bancarias': 'Maximum bank accounts',
    'Porcentaje Penalidad Retiro Saldo Recargas': 'Percentage Penalty Withdrawal Balance Refills',
    'Especifique el porcentaje de la penalidad por retiro a saldo de recargas.':
        'Specify the percentage of the penalty for withdrawal to top-up balance.',
    'Porcentaje Invalido': 'Invalid Percentage',
    'Inactividad de sesión en minutos': 'Session inactivity in minutes',
    'Establezca el tiempo de inactividad en minutos para el cierre de sesión.':
        'Set the idle time in minutes for logging out.',
    'Duración de la sesión en minutos': 'Session duration in minutes',
    'Establezca la duración de la sesión de juego en minutos.': 'Set the duration of the game session in minutes.',
    'URL fondo casino': 'URL casino background',
    'Establezca la URL de la imagen para fondo de casino.': 'Set the image URL for casino background.',
    'Impuesto Retiro Saldo Deposito a partir de': 'Tax Withdrawal Balance Deposit from',
    'Impuesto por Retiro Saldo Deposito a partir de un valor': 'Withdrawal Tax Balance Deposit based on a security',
    'Requiere registro activo para iniciar sesión?': 'Do you need active registration to log in?',
    'Mínimo Retiro de Recargas para Penalizar': 'Minimum Recharge Withdrawal to Penalize',
    'Especifique el monto mínimo de retiro de saldo recargas para penalizar.':
        'Specify the minimum amount of withdrawal of balance refills to penalize.',
    'Liquidaciones generadas': 'Liquidations generated',
    'Contigencia Total': 'Total Contingency',
    Automáticas: 'Automatic',
    Manuales: 'Manuals',
    'Informacíon Actualizada': 'Updated information',
    'Días de expiración de la contraseña temporal': 'Days of expiration of the temporary password',
    'Solicitudes de Depósitos': 'Deposit Request',
    'Recepción de Efectivo': 'Cash Receipt',
    'Aprobar Depósito': 'Approve Deposit',
    'Rechazar Depósito': 'Reject Deposit',
    'Método de pago cuentas bancarias': 'Bank Account Payment Method',
    'Pagado físicamente': 'Physically paid',
    'Pagado por sistema': 'Paid through system',
    'Método de pago': 'Payment method',
    'Aprobar Nota': 'Approve Note',
    'Desea Aprobar Nota de Retiro?': 'Do you want to Approve Withdrawal Note?',
    'Rechazar Nota': 'Reject Note',
    'Desea Rechazar Nota de Retiro?': 'Want to Decline Withdrawal Note?',
    'Ver por un cajero en especifico': 'See for a specific cashier',
    Volver: 'Return',
    'Ingresos Tarjetas de crédito': 'Income Credit Cards',
    'Otros Egresos': 'Other expenses',
    'Añadir ingreso por tarjeta': 'Add card entry',
    'Cerrar día': 'Close day',
    'No hay datos': 'There is no data',
    'Especifique si el usuario quedara automáticamente activado después del registro':
        'Specify if the user is automatically activated after registration',
    'Usuario automáticamente activado': 'User automatically activated',
    'Limite depósito día por defecto': 'Limit day deposit by default',
    'Especifique el límite de depósito diario por defecto': 'Specify the default daily deposit limit',
    'Limite depósito semana por defecto': 'Limit deposit week by default',
    'Especifique el límite de depósito semanal por defecto': 'Specify the default weekly deposit limit',
    'Limite depósito mes por defecto': 'Limit deposit month by default',
    'Especifique el límite de depósito mensual por defecto': 'Specify the default monthly deposit limit',
    'Limite depósito día global': 'Limit day deposit global',
    'Especifique el límite de depósito diario global': 'Specify the global daily deposit limit',
    'Limite depósito semana global': 'Limit deposit week global',
    'Especifique el límite de depósito semanal global': 'Specify the global weekly deposit limit',
    'Limite depósito mes global': 'Limit deposit month global',
    'Especifique el límite de depósito mensual global': 'Specify the global monthly deposit limit',
    'Máximo intentos inicio sesión': 'Maximum login attempts',
    'Especifique el número máximo de intentos para iniciar sesión': 'Specify the maximum number of attempts to log in',
    'Mínimo retiros punto': 'Minimum point withdrawals',
    'Mínimo monto en solicitud de retiro por punto de venta': 'Minimum amount in withdrawal request per point of sale',
    Competidor: 'Competition',
    'Desea cancelar la cuenta del punto de venta?': 'Do you want to cancel the BetShop account?',
    'Fecha Pagado': 'Payment Date',
    'Tipo de cuenta': 'Account type',
    'Configuración Partner': 'Partner Settings',
    'No tienes un QR Configurado, por favor comunicarse con soporte.':
        'You do not have a QR Configured, please contact support.',
    30003: 'The user or password is incorrect.',
    'Zona horaria:': 'Time zone:',
    'Moneda para reportes': 'Currency for reports',
    'Impuesto sobre apuesta al pagar premio': 'Betting tax when paying prize',
    'Impuesto sobre el monto de la apuesta al momento de pagar el premio':
        'Tax on the amount of the bet when paying the prize',
    'Verificó DNI posterior?': 'Is Back side ID Verified?',
    'Verificó DNI anterior?': 'Is Front side ID Verified?',
    'Tipo de liquidaciones comisiones': 'Type of commission settlements',
    'Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.':
        'Specify the type of settlements for commissions, either by cash or by closing.',
    Cierre: 'Closing',
    'Cierre Pagada': 'Closing Paid',
    'El usuario o la clave son incorrectos.  (Report#30003)': 'The username or password is incorrect.  (Report#30003)',
    'Premio Total': 'Net Winnings',
    'Total Caja:': 'Total Cash:',
    'Se cerró el día satisfactoriamente': 'The day was successfully closed',
    'Ya se efectuó el cierre de día, nos es posible realizar esta operación':
        'The closing of the day has already been made, we can perform this operation',
    'Ticket Ganador': 'Winning Ticket',
    'Ticket Perdedor': 'Losing Ticket',
    'Ticket Pendiente': 'Pending Ticket',
    'Ticket no encontrado': 'Ticket not found',
    'Nota de retiro no encontrada': 'Withdrawal Note Not Found',
    'Nota de retiro pagada': 'Withdrawal Note Paid',
    'Confirmar Valor:': 'Confirm Value:',
    'Confirmar Valor': 'Confirm Value',
    'Valores no coinciden': 'Values ​​do not match',
    'Ya se efectuó el cierre de día, no es posible realizar esta operación':
        'The closing of the day has already been carried out, it is not possible to perform this operation',
    'Apuestas Deportivas': 'Sports bets',
    'Apuestas deportivas en vivo': 'Live sports betting',
    'Apuestas Virtuales': 'Virtual Bets',
    'El usuario no se encuentra o ya fue activado': 'The user is not found or has already been activated',
    'Premio pagado satisfactoriamente': 'Prize paid successfully',
    'ID Afiliador': 'ID Affiliate',
    'Nombre Afiliador': 'Affiliate Name',
    'Recargas Eliminadas': 'Eliminated Top-ups',
    'Cupo Recarga E': 'Quota Recharges E',
    'Cupo Recarga S': 'Quota Recharges S',
    'Cupo recargas inicial': 'Initial Top-Up Balance',
    'Cupo juego inicial': 'Initial Game Balance',
    'Cupo recargas final': 'End recharge quota',
    'Cupo recargas final Calc.': 'End game quota calculated',
    'Cupo juego final': 'End game quota',
    'Cupo juego final Calc.': 'End game quota calculated',
    'Historial de saldo punto de venta': 'Balance History BetShop',
    'Cupo Apuesta E': 'Quota Bet E',
    'Cupo Apuesta S': 'Quota Bet S',
    'Punto de venta propio?': 'Own BetShop?',
    'Tipos de documentos': 'Types of documents',
    'Tipo de documento agregado': 'Type of document added',
    'Tipo de documento actualizado': 'Type of document updated',
    'Añadir tipo de documento': 'Add document type',
    'Editar tipo de documento': 'Edit Document Type',
    'Serie:': 'Serie:',
    'Tipo documento:': 'Type Document:',
    'Impuesto:': 'Tax:',
    'Saldo Antes de Ajuste': 'Balance Before Adjustment',
    'Saldo Despues de Ajuste': 'Balance After Adjustment',
    'Numero Autoexclusiónes': 'Number of self-exclusions',
    'Motivo Autoexclusión': 'Self-exclusion motive',
    'Fondos Depositados': 'Deposit Funds',
    'Fondos Retirados': 'Withdrawn Funds',
    'Fondos Restantes de Juegos Incompletos': 'Remaining Funds of Incomplete Games',
    'Requiere registro activo para depositar?': 'Does it require active registration to deposit?',
    'Especifique si el usuario necesita tener el registro activado para poder depositar':
        'Specify if the user needs to have the registration activated in order to deposit',
    'Requiere verificación de cuenta para depositar?': 'Requires account verification to deposit?',
    'Especifique si el usuario necesita verificar cuenta para poder depositar':
        'Specify if the user needs to verify account in order to deposit',
    'Requiere registro activo para retirar?': 'Does it require active registration to withdraw?',
    'Especifique si el usuario necesita tener el registro activado para poder retirar':
        'Specify if the user needs to have the registration activated in order to withdraw',
    'Requiere verificación de cuenta para retirar?': 'Requires account verification to withdraw?',
    'Especifique si el usuario necesita verificar cuenta para poder retirar':
        'Specify if the user needs to verify account in order to withdraw',
    'Tipo de comisión puntos de venta': 'Type of commission bet shop',
    'Especifique el tipo de comisión para los puntos de venta.': 'Specify the type of commission for the bet shop.',
    'Logs Usuario General': 'Logs User General',
    'Especifique el tipo de comisión para los puntos de venta.': 'Specify the type of commission for the bet shop.',
    Explicación: 'Reason',
    'Reporte General Logs': 'General Logs Report',
    Elemento: 'Element',
    'Valor antes': 'Value before',
    'Valor despues': 'Value after',
    'Usuarios Depositantes': 'Users who Deposited',
    'Cantidad Depositos': 'Number of Deposits',
    'Ordenar por': 'Sort by',
    Orden: 'Order',
    Ascendente: 'Ascending',
    Descendente: 'Descending',
    Cajero: 'Cashier',
    'Historico Saldos Punto Venta': 'Bet Shops Balance Record',
    'Reporte Comisiones Global': 'Global Commissions Report',
    'Desea cerrar día?': 'Do you want to close day?',
    Impuestos: 'Taxes',
    'Fecha de exportación: ': 'Export Date: ',
    'Confirme recarga de ': 'Confirm recharge of ',
    ' para el usuario ': ' for the user ',
    'Tipo de Saldo': 'Type of Balance',
    'Saldo de Recargas': 'Top-up Balance',
    Continuar: 'Continue',
    'Reporte de Transferencias': 'Transfer Report',
    'Usuario Creó': 'User Created',
    'Usuario Recibió': 'User Received',
    'Fecha de reporte: Desde ': 'Report Date: From ',
    ' Hasta ': ' to ',
    'Desea Rechazar la Retracción de Saldo?': 'Do you want to Reject Balance Retraction?',
    'Estado de Retracción actualizado': 'Updated Retraction Status',
    'Desea Aprobar el Retracción de Saldo?': 'Do you want to Approve Balance Retraction?',
    'Aprobación de Retracción de Saldo': 'Balance Withdrawal Approval',
    'Te estas logueando desde el sitio equivocado.': 'You are logging in from the wrong site.',
    '¡Serás redireccionado a tu sitio!': '¡You will be redirected to your site!',
    '¡Atención!': '¡Attention!',
    'IR AL SITIO': 'GO TO THE SITE',
    'Punto Venta Pagó': 'Bet Shop Payment',
    '¿Es de movimiento de base de caja?': 'Is it from cash base movement?',
    'Centro de costo personalizado': 'Custom cost center',
    'Apuestas Anuladas': 'Voided Placed Bets',
    'Apuestas Pagadas Anuladas': 'Voided Paid Bets',
    'Estado Celular': 'Cell Status',
    'Sin verificar': 'Unverified',
    'Descripción del reporte: Flujo Caja Resumido': 'Report Description: Cash Flow Summary',
    'Fecha creación del reporte: ': 'Report creation date: ',
    'Flujo Caja Resumido': 'Summary Cash Flow',

    'Sub Diario': 'Sub Diario',
    'Número de Comprobante': 'Número de Comprobante',
    'Fecha de Comprobante': 'Fecha de Comprobante',
    'Código de Moneda': 'Código de Moneda',
    'Glosa Principal': 'Glosa Principal',
    'Tipo de Cambio': 'Tipo de Cambio',
    'Tipo de Conversión': 'Tipo de Conversión',
    'Flag de Conversión de Moneda': 'Flag de Conversión de Moneda',
    'Fecha Tipo de Cambio': 'Fecha Tipo de Cambio',
    'Cuenta Contable': 'Cuenta Contable',
    'Código de Anexo': 'Código de Anexo',
    'Código de Centro de Costo': 'Código de Centro de Costo',
    'Debe / Haber': 'Debe / Haber',
    'Importe Original': 'Importe Original',
    'Importe en Dólares': 'Importe en Dólares',
    'Importe en Soles': 'Importe en Soles',
    'Tipo de Documento': 'Tipo de Documento',
    'Número de Documento': 'Número de Documento',
    'Fecha de Documento': 'Fecha de Documento',
    'Fecha de Vencimiento': 'Fecha de Vencimiento',
    'Código de Area': 'Código de Area',
    'Glosa Detalle': 'Glosa Detalle',
    'Código de Anexo Auxiliar': 'Código de Anexo Auxiliar',
    'Medio de Pago': 'Medio de Pago',
    'Tipo de Documento de Referencia': 'Tipo de Documento de Referencia',
    'Número de Documento Referencia': 'Número de Documento Referencia',
    'Fecha Documento Referencia': 'Fecha Documento Referencia',
    'Nro Máq. Registradora Tipo Doc. Ref.': 'Nro Máq. Registradora Tipo Doc. Ref.',
    'Base Imponible Documento Referencia': 'Base Imponible Documento Referencia',
    'IGV Documento Provisión': 'IGV Documento Provisión',
    'Tipo Referencia en estado MQ': 'Tipo Referencia en estado MQ',
    'Número Serie Caja Registradora': 'Número Serie Caja Registradora',
    'Fecha de Operación': 'Fecha de Operación',
    'Tipo de Tasa': 'Tipo de Tasa',
    'Tasa Detracción/Percepción': 'Tasa Detracción/Percepción',
    'Importe Base Detracción/Percepción Dólares': 'Importe Base Detracción/Percepción Dólares',
    'Importe Base Detracción/Percepción Soles': 'Importe Base Detracción/Percepción Soles',
    'Tipo Cambio para F': 'Tipo Cambio para F',
    'Importe de IGV sin derecho crédito fiscal': 'Importe de IGV sin derecho crédito fiscal',
    'Ver T.G. 02': 'Ver T.G. 02',
    'Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo':
        'Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo',
    'Ver T.G. 03': 'Ver T.G. 03',
    "Llenar  solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999":
        "Llenar  solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999",
    "Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha":
        "Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha",
    "Solo: 'S' = Si se convierte, 'N'= No se convierte": "Solo: 'S' = Si se convierte, 'N'= No se convierte",
    "Si  Tipo de Conversión 'F'": "Si  Tipo de Conversión 'F'",
    'Debe existir en el Plan de Cuentas': 'Debe existir en el Plan de Cuentas',
    'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos':
        'Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos',
    'Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05':
        'Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05',
    "'D' ó 'H'": "'D' ó 'H'",
    'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ':
        'Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ',
    "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ":
        "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ",
    "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ":
        "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ",
    'Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06':
        'Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06',
    'Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número':
        'Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número',
    'Si Cuenta Contable tiene habilitado el Documento Referencia':
        'Si Cuenta Contable tiene habilitado el Documento Referencia',
    'Si Cuenta Contable tiene habilitada la Fecha de Vencimiento':
        'Si Cuenta Contable tiene habilitada la Fecha de Vencimiento',
    'Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26':
        'Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26',
    'Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia':
        'Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia',
    "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'":
        "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'",
    "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06": "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número":
        "Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'":
        "Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'": "Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'":
        "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'",
    "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'":
        "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket":
        "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket",
    "Si la Cuenta Contable tiene configurada la Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29":
        "Si la Cuenta Contable tiene configurada la Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29",
    "Si la Cuenta Contable tiene conf. en Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99":
        "Si la Cuenta Contable tiene conf. en Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99",
    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99':
        'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
    'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99':
        'Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99',
    "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.":
        "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.",
    'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx':
        'Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx',
    'Exportación Masiva': 'Mass Export',
    'Cuenta de cancelación': 'Cancellation account',
    'Estado de Contingencia Retiro': 'Contingency Status Withdrawal',
    'Estado de Contingencia Deposito': 'Contingency Status Deposit',
    'Estado Especial': 'Special State',
    'Proveedor de SMS': 'SMS provider',
    'Proveedor de Email': 'Email Provider',
    'Cerrar día especifico': 'Close specific day',
    'Descripción del reporte: Flujo Caja Resumido ': 'Report Description: Summary Cash Flow ',
    ' Fecha creación del reporte: ': ' Report creation date: ',
    Serie: 'Serie',
    'QR Copiado!': 'QR Copied!',
    'Enviar código al celular': 'Send code to cell phone',
    'Código enviado': 'Sent code',
    '¿Producto tiene cupo?': '¿Product has a quota?',
    'Productos terceros con cupo': 'Products third with quota',
    'Agregar cupo': 'Add Quota',
    'Cupo Agregado': 'Quota Added',
    'Ingreso editado satisfactoriamente': 'Successfully edited income',
    'Editar Ingreso': 'Edit Income',
    'Editar Egreso': 'Edit Expense',
    'Egreso editado satisfactoriamente': 'Successfully edited expense',
    'Ingreso por tarjeta de crédito editado satisfactoriamente': 'Credit card income edited successfully',
    Identificador: 'Identifier',
    Todas: 'All',
    Expiradas: 'Expired',
    'Proveedor pagos de retiros': 'Withdrawal payment provider',
    'Añadir Ingreso Producto Cupo': 'Add Product Income Quota',
    'Producto:': 'Product:',
    'Cuenta Contable Cierre': 'Accounting Account Closing',
    '¿Somos agentes?': 'Are we agents?',
    'Máximo monto por retiro': 'Maximum withdrawal amount',
    'Máximo monto pago premio': 'Maximum prize payment amount',
    'Por fecha de retiro pagado': 'Sort by withdrawal payment date',
    'Banner Invasivo': 'Invasive banner',
    Popup: 'Popup',
    Franja: 'Fringe',
    'Fecha Caducidad Pago': 'Payment Expiration Date',
    'Enviar banner invasivo': 'Send invasive banner',
    'Enviar popup': 'Send popup',
    'Enviar franja': 'Send fringe',
    'URL Imagen': 'Image URL',
    'URL Redirección': 'URL Redirection',
    Contenido: 'Content',
    'Texto del botón': 'Button text',
    'Usuarios Id': 'Id Users',
    'Fecha envío': 'Send date',
    'Fecha expiración': 'Expiration date',
    '¿Es un juego?': "It's a game?",
    'Ir al usuario': 'Go to user',
    'Categorías sin agregar': 'Categories without adding',
    'Categorías Producto Partner': 'Categories Product Partner',
    'Seleccione por lo menos un Partner': 'Select at least one Partner',
    'Partners Seleccionados': 'Selected Partners',
    'Partners no Seleccionados': 'Unselected partners',
    'Sub Proveedor': 'Sub Provider',
    'Franja Superior': 'Upper Fringe',
    'Desea Eliminar Egreso?': 'Do you want to Delete Expense?',
    'Eliminar Egreso': 'Delete Expense',
    'Egreso Eliminado': 'Eliminated Expense',
    'Desea Eliminar Ingreso?': 'Do you want to delete income?',
    'Eliminar Ingreso': 'Delete Income',
    'Ingreso Eliminado': 'Eliminated Income',
    'Apuestas Canceladas': 'Canceled Bets',
    'Partner Referencia': 'Partner Reference',
    'Tipo de registro': 'Type of register',
    'Especifique tipo de registro si es corto o largo': 'Specify type of register if it is short or long',
    Corto: 'Short',
    Largo: 'Long',
    'No Expiradas': 'Not expired',
    Plantillas: 'Templates',
    'Plantilla email guardada': 'Saved email template',
    'Plantilla sms guardada': 'Saved sms template',
    Ninguno: 'None',
    'Pagado fisicamente': 'Physically paid',
    'Rechazar nota de retiro': 'Reject withdrawal note',
    'Elija la forma de pago': 'Choose the payment method',
    'Pagar Nota': 'Pay Note',
    'Desea Pagar Nota de Retiro?': 'Do you want to Pay a Withdrawal Note?',
    'Nota de Retiro Rechazada': 'Withdrawal Note Rejected',
    'Nota de Retiro Aprobado': 'Approved Withdrawal Note',
    'Reporte de billeteras': 'Wallet report',
    'Desea Activar Billetera?': 'Do you want to Activate Wallet?',
    'Activar Billetera': 'Activate Wallet',
    'Billetera Activada': 'Activated Wallet',
    'Desea Inactivar Billetera?': 'Do you want to Inactivate Wallet?',
    'Inactivar Billetera': 'Inactivate Wallet',
    'Billetera Inactivada': 'Inactive Wallet',
    Resumido: 'Summarized',
    'Configuración SEO': 'Settings SEO',
    'Leido?': 'Read?',
    'Información Extra': 'Extra information',
    'Reporte de transacciones del saldo': 'Balance transaction report',
    'Desea aprobar notas de retiro seleccionadas?': 'Do you want to approve selected withdrawal notes?',
    'Aprobar Notas': 'Approve Notes',
    'Notas de retiro aprobadas': 'Approved withdrawal notes',
    'Seleccione por lo menos una nota de retiro para aprobar': 'Select at least one withdrawal note to approve',
    '¿Es nuevo?': "It's new?",
    '¿Esta seguro de realizar cambios en la configuración del SEO?':
        'Are you sure about making changes to your SEO settings?',
    'Añadir SEO': 'Add SEO',
    Idioma: 'Language',
    'PÁGINA:': 'PAGE:',
    'Historial de transferencias de saldo': 'Balance transfer history',
    'Confirme retracción de ': 'Confirm retraction of ',
    Retraer: 'Retract',
    'Transferir a Usuario': 'Transfer User',
    'Retracción a Usuario': 'User Retraction',
    'Valor Invalido': 'Invalid Value',
    'Activa o inactiva el tipo de saldo recargas': 'Activate or inactivate the type of balance recharge',
    'Activa o inactiva el tipo de saldo retiros': 'Activate or inactivate the type of balance withdrawals',
    'Saldo bonos': 'Balance bonos',
    'Activa o inactiva el tipo de saldo bonos': 'Activate or inactivate the type of balance bonuses',
    'Saldo freebet': 'Balance freebet',
    'Activa o inactiva el tipo de saldo freebet': 'Activate or inactivate the type of balance freebet',
    'Saldo freecasino': 'Balance freecasino',
    'Activa o inactiva el tipo de saldo freecasino': 'Activate or inactivate the type of balance freecasino',
    'Retracción a Saldo Juego': 'Retraction to Balance Game',
    'Retracción a Saldo Recargas': 'Retraction to Balance recharge',
    Sección: 'Section',
    'Id de transacción relacionada': 'Related transaction id',
    'Historial de transferencias de saldo realizadas': 'History of balance transfers made',
    'Historial de transferencias de saldo recibidas': 'History of balance transfers received',
    'Transferir Saldo a ': 'Transfer Balance to',
    'Historial de saldo agentes': 'Agents Balance Record',
    'Historial de saldo usuario administrativo': 'Administrators Balance Record',
    'Bonos casino': 'Casino bonus',
    'Bonos Virtuales': 'Virtual bonus',
    'Bonos Casino en vivo': 'Live casino bonus',
    'Fecha Cambio': 'Modification Date',
    'Fecha Acción': 'Action Date',
    'Fecha Cierre': 'Settlement Date',
    'Usuario Pagó': 'User Paid',
    'Impuesto Apuesta': 'Bet Tax',
    'Impuesto Apuestas': 'Bets Tax',
    'Impuesto Premios': 'Winnings Tax',
    'Impuesto Premio': 'Winning Tax',
    'Con pasarelas de pago?': 'With payment gateways?',
    'Su sesión se ha perdido, acceda nuevamente.': 'Your session has been lost, log in again.',
    Aceptar: 'To accept',
    'Con apuestas anuladas?': 'With canceled bets?',
    'Con premios pendientes?': 'With pending awards?',
    'Esta nota de retiro no tiene permitido el pago por sistema':
        'This withdrawal note is not allowed to pay per system',
    'Agregar Archivo': 'Add file',
    'Se ha realizado la Actualización satisfactoriamente.': 'The Update was successful.',
    'Historial de saldo máquinas': 'Machine balance history',
    'Flujo Caja Resumido Máquina': 'Machine Summary Cash Flow',
    'Máquina Productos': 'Products Machine',
    'Máquina Proveedores': 'Provider Machine',
    'Máquina Sub Proveedores': 'Sub Provider Machine',
    'Máquina Tipo': 'Machine Type',
    'Máquina Referencia': 'Reference Machine',
    'Categoría Máquina Editado': 'Edited Machine Category',
    'Producto Máquina Editado': 'Edited Machine Products',
    'Proveedor Máquina Editado': 'Edited Machine Provider',
    'Sub Proveedor Máquina Editado': 'Edited Machine Sub Provider',
    'Tipo producto Máquina Editado': 'Edited Machine Type',
    'Agrupado sólo por usuario afiliador': 'Grouped only by affiliate user',
    'Id Sistema': 'System Id',
    'Ver sólo por punto de venta': 'See only by BetShop',
    'Proveedores internos': 'Internal suppliers',
    'Programa de lealtad': 'Loyalty program',
    'Puntos requeridos para el nivel 1': 'Points required for level 1',
    'Puntos requeridos para el nivel 2': 'Points required for level 2',
    'Puntos requeridos para el nivel 3': 'Points required for level 3',
    'Puntos requeridos para el nivel 4': 'Points required for level 4',
    'Puntos requeridos para el nivel 5': 'Points required for level 5',
    'Puntos requeridos para el nivel 6': 'Points required for level 6',
    'Puntos requeridos para el nivel 7': 'Points required for level 7',
    'Puntos requeridos para el nivel 8': 'Points required for level 8',
    'Puntos requeridos para el nivel 9': 'Points required for level 9',
    'Puntos requeridos para el nivel 10': 'Points required for level 10',
    'Monto depósito': 'Deposit amount',
    'Monto (Dinero) requerido de los depósitos para obtener Z punto':
        'Amount (Money) required from deposits to get Z point',
    'Deportiva simple': 'Simple sporty',
    'Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto':
        'Amount (Money) required of a simple sports bet to get Z point',
    'Deportiva combinada de 2': 'Sports combined 2',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto':
        'Amount (Money) required from a Combination of 2 sports bet to earn Z point',
    'Deportiva combinada de 3': 'Sports combined 3',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto':
        'Amount (Money) required of a Combination of 3 sports bet to get Z point',
    'Deportiva combinada de 4': 'Sports combined 4',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto':
        'Amount (Money) required of a Combination of 4 sports bet to earn Z point',
    'Deportiva combinada de 5': 'Sports combined 5',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto':
        'Amount (Money) required from a Combination of 5 sports bet to earn Z point',
    'Deportiva combinada de 6': 'Sports combined 6',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto':
        'Amount (Money) required of a 6 pound sports bet to earn Z point',
    'Deportiva combinada de 7': 'Sports combined 7',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto':
        'Amount (Money) required from a Combination 7 sports bet to earn Z point',
    'Deportiva combinada de 8': 'Sports combined 8',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto':
        'Amount (Money) required of a Combined 8 sports bet to earn Z point',
    'Deportiva combinada de 9': 'Sports combined 9',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto':
        'Amount (Money) required of a Combined 9 sports bet to earn Z point',
    'Deportiva combinada de 10': 'Sports combined 10',
    'Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto':
        'Amount (Money) required of a Combination of 10 sports bet to earn Z point',
    'Premios deportivos': 'Sports awards',
    'Monto (Dinero) requerido de premios deportivos para obtener Z punto':
        'Amount (Money) required of sports awards to obtain Z point',
    'Apuestas de casino': 'Casino bets',
    'Monto (Dinero) requerido de apuestas de casino para obtener Z punto':
        'Amount (Money) required of casino bets to get Z point',
    'Premios de casino': 'Casino awards',
    'Monto (Dinero) requerido de premios de casino para obtener Z punto':
        'Amount (Money) required of casino prizes to get Z point',
    'Monto requerido de retiros': 'Required amount of withdrawals',
    'Monto (Dinero) requerido de retiros para obtener Z punto':
        'Amount (Money) required of withdrawals to obtain Z point',
    'Puntos Base': 'Base Points',
    'Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.':
        'Specify the number of points to be taken as a base, equivalent to Z in the other items.',
    'Tipos de movimientos': 'Types of movements',
    'Puntos equivalentes por nivel': 'Equivalent points per level',
    'IP de Cambio': 'Change Ip',
    'Ip Acción': 'Action Ip',
    'Puntos Lealtad': 'Loyalty Points',
    Observaciones: 'Observations',
    'Impuesto del GGR de la apuesta al momento de pagar': 'GGR tax of the bet at checkout',
    'Días de expiración de puntos': 'Points expiration days',
    'Especifique el tiempo en días para la caducidad de los puntos':
        'Specify the time in days for the expiration of the points',
    'Depositos:': 'Deposits:',
    'Apuestas en Deportivas:': 'Sports Betting:',
    'Apuestas en Casino:': 'Casino bets:',
    'Total Apuestas:': 'Total Bets:',
    'Premios en Deportivas:': 'Sports Winnings:',
    'Premios en Casino:': 'Casino Winnings:',
    'Total Premios:': 'Total Winnings:',
    'Notas pendientes:': 'Pending Notes:',
    'Valor Retirado:': 'Withdrawn Value:',
    'Bonos:': 'Bonuses:',
    'Bonos Free Ganados:': 'Free Bonuses Earned:',
    'Ajustes Entrada:': 'Input Settings:',
    'Ajustes Salida:': 'Output Settings:',
    'Total:': 'Total:',
    'Desea realizar movimiento?': 'Do you want to move?',
    'Reporte de Sesiones Casino': 'Session Report Casino',
    'Máximo monto retiro por punto de venta': 'Maximum withdrawal amount per bet shop',
    'Especifique el monto máximo para retirar por punto de venta':
        'Specify the maximum amount to withdraw per bet shop',
    'Saldo al Final': 'Balance at End',
    'Valor de depósitos': 'Deposit value',
    'Apuestas deportivas': 'Sports bets',
    'Premios deportivos': 'Sports awards',
    'Cancelaciones deportivas': 'Sports cancellations',
    'Apuestas de casino': 'Casino gambling',
    'Premios de casino': 'Casino prizes',
    'Cancelaciones de casino': 'Casino cancellations',
    'Retiros realizados': 'Withdrawals made',
    'Retiros cancelados': 'Canceled withdrawals',
    'Bonos redimidos': 'Bonds redeemed',
    Encriptación: 'Encryption',
    'Desea imprimir recibo?': 'Do you want to print a receipt?',
    Imprimir: 'Print',
    'Verificó domicilio': 'Verified address',
    'Link Afiliados:': 'Affiliate Link:',
    'QR Afiliados:': 'QR Affiliates:',
    'Saldo:': 'Balance:',
    Billetera: 'Wallet',
    Comisión: 'Commission',
    'Transferencias recibidas': 'Transfers received',
    'Transferencias realizadas': 'Transfers made',
    'Reporte de retiros': 'Withdrawal Report',
    'Reporte de Depósitos Punto de venta': 'Bet Shop Deposits Report',
    'Reporte de Retiros Punto de Venta': 'Bet Shop Withdrawal Report',
    'Fecha de pago': 'Payment date',
    'Reporte de transferencias de saldo Recibidas': 'Received Balance report',
    'Reporte de transferencias de saldo Realizadas': 'Delivered Balance report',
    'Tipo de Billetera': 'Wallet Type',
    'Reporte de Afiliados': 'Affiliate report',
    'Recepcion de Efectivo': 'Cash Receipt',
    'ID Billetera': 'Wallet ID',
    'Reporte de Billeteras': 'Wallet Report',
    'Desea Inactivar Billetera?': 'Do you want to Inactivate Wallet?',
    'Billetera Inactivada': 'Inactivated Wallet',
    Billeteras: 'Wallets',
    Cupones: 'Coupons',
    'Desea enviar el cupón?': 'Do you want to send the coupon?',
    'Cupón Enviado Satisfactoriamente': 'Coupon Sent Successfully',
    'Cantidad:': 'Quantity:',
    'Transf Apuesta E': 'Bet Transf E',
    'Transf Apuesta S': 'Bet Transf S',
    'Transf Recarga E': 'Top-up Transf E',
    'Transf Recarga S': 'Top-up Transf S',
    'Calc. Desfase': 'Calculation of financial gap – Imbalance',
    Cupo: 'Quota',
    'Cupo Calc.': 'Calculation Quota',
    'Complete Datos': 'Complete blank spaces',
    'Cajero:': 'Cashier:',
    'Reporte de casino ': 'Casino Report',
    'Historico Saldos Agentes': 'Agents Balance Record',
    'Historico Saldos Administrativos': 'Administrators Balance Record',
    'Transferencias de saldo': 'Balance Transfer',
    'Retracción de saldo': 'Balance Retraction',
    'ID Final': 'Final ID',
    'ID Retiro': 'Withdrawal ID',
    Enviada: 'Send',
    'Fecha de Eliminación': 'Date of Elimination',
    'Consolidado nivel': 'Consolidated amount',
    'No tiene permitido el pago por sistema': 'Payment by system is not allowed',
    'Editar Proveedor': 'Edit Provider',
    SubProveedor: 'Sub provider',
    Observación: 'Observation',
    'Ajuste de Saldo': 'Balance Adjustment',
    'Apuestas Casino': 'Casino Bets',
    'Nota de retiro Creada': 'Withdrawal note Created',
    'Nota de retiro Pagada': 'Withdrawal Note Paid',
    'Bono Redimido': 'Bonus Redeemed',
    'Aumento de cupo': 'Quota increase',
    'Cuenta deshabilitada': 'Disable Account',
    'Cambio de contraseña': 'Change password',
    'Valores no permitiros...': 'Values not allow ...',
    Códigos: 'Codes',
    DNI: 'ID verification',
    'Pendiente por Sistema': 'Pending by system',
    'Aprobado por Sistema': 'Approved by system',
    'Rechazado por Sistema': 'Rejected by system',
    'ID Concesionario': 'Agent ID',
    'Parte Superior Impresión recibo de pago de premio': 'Top Print receipt of payment of prize',
    'Parte Inferior Impresión recibo de pago de premio': 'Bottom Print receipt of payment of prize',
    'Parte Superior Impresión recibo de pago de retiro': 'Top Print withdrawal payment receipt',
    'Parte Inferior Impresión recibo de pago de retiro': 'Bottom Print withdrawal payment receipt',
    'Impuesto al pago de premio (GGR)': 'Prize payment tax (GGR)',
    'Es Propio?': 'Is it your own?',
    'Tipo de Punto': 'Point Type',
    Físico: 'Physical',
    '(Nota: Por cada monto en XXX va a obtener Z puntos base)':
        '(Note: For each amount in XXX you will get Z basis points)',
    'Número de teléfono:': 'Phone number:',
    'Tipo de establecimiento': 'Type of establishment',
    'Sportbook NGR Afiliados': 'Sportbook NGR Affiliates',
    'Sportbook GGR Punto venta IP': 'Sportbook GGR Point of sale IP',
    'Sportbook GGR Punto venta': 'Sportbook GGR Point of sale',
    'Deposito Punto venta': 'Point of sale deposit',
    'Nro. de Agente:': 'Agent number:',
    'Nombre del agente:': 'Agent Name:',
    'Recargar Credito Agente': 'Top up Agent Credit',
    'Solo Saldos Negativos': 'Only Negative Balances',
    'Contingencia Total': 'Total contingency',
    'Contingencia Deportivas': 'Sports contingency',
    'Contingencia Casino': 'Casino contingency',
    'Contingencia Casino en Vivo': 'Live Casino Contingency',
    'Contingencia Virtuales': 'Virtual contingency',
    'Contingencia Poker': 'Poker contingency',
    'Contingencia Retiro': 'Retirement contingency',
    'Contingencia Depósito': 'Deposit Contingency',
    'Contingencia masiva': 'Massive contingency',
    'Cargar archivo CSV': 'Upload CSV file',
    'Contingencia masiva creada': 'Massive contingency created',
    'V. Entradas Recargas Agentes': 'V. Tickets Refills Agents',
    'Valor Entradas Recargas Agentes': 'Value Tickets Refills Agents',
    'Configuración Tabla': 'Table Configuration',
    'Premio Pagado': 'Prize Paid',
    'No tiene permitido esta acción': 'You are not allowed this action',
    'Añadir bono masivo': 'Add massive bonus',
    'Tipo Transferencia': 'Transfer Type',
    'Tipo Reporte': 'Report Type',
    'GGR. Deportivas': 'GGR. Sports',
    'GGR. Casino': 'GGR. Casino',
    Tipoo: 'Type',
    'Sucursal bancaria': 'Bank branch',
    'Tipo de ajuste': 'Adjustment type',
    Fraude: 'Fraud',
    'Traslado usuario inactivado': 'Transfer user inactivated',
    Redondeo: 'Rounding',
    'Apuestas erróneas casino': 'Casino wrong bets',
    Pruebas: 'Tests',
    Otros: 'Others',
    'Cedula de Ciudadania': 'Electoral ID',
    'Cedula de Extranjeria': 'Drivers license',
    'Recargas Anuladas': 'Canceled Deposits',
    'Id punto de venta': 'Betshop ID',
    'Nombre punto de venta': 'Betshop Name',
    'Reportes personalizados': 'Custom reports',
    Generado: 'Generated',
    'Cantidad Registros': 'Number of Records',
    'Solicitar Reporte': 'Request Report',
    'Link Reporte': 'Link Report',
    'Reporte solicitado correctamente': 'Report successfully requested',
    'Buscar Permiso': 'Search Permission',
    Usuario: 'User',
    Global: 'Global',
    Operación: 'Operation',
    'Tipo de acción': 'Action type',
    Autorizaciones: 'Authorizations',
    Bloqueos: 'Blocks',
    'Desea rechazar notas de retiro seleccionadas?': 'Do you want to reject selected withdrawal notes?',
    'Rechazar Notas': 'Reject Notes',
    'Notas de retiro rechazadas': 'Withdrawal notes rejected',
    'Seleccione por lo menos una nota de retiro para rechazar': 'Select at least one withdrawal note to reject',
    Sitio: 'Site',
    'Anular Transferencia': 'Cancel Transfer',
    'Transferencia Anulada': 'Transfer Canceled',
    'Monto y confirmar monto no coinciden': 'Amount and confirm amount do not match',
    'Olvidó su contraseña?': 'Forgot your password?',
    'Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.':
        'The message has been sent correctly, you will receive an email with the information.',
    'Email Inválido': 'Invalid Email',
    'Mínimo 8 caracteres, una minúscula, una mayúscula y un número.':
        'Minimum 8 characters, one lower case, one upper case and a number.',
    'Contraseña cambiada satisfactoriamente.': 'Password changed successfully.',
    'Nueva contraseña y confirmar contraseña no coinciden.': 'New password and confirm password do not match.',
    'Nro. de Usuario:': 'User number:',
    'Nombre del Usuario:': 'User name:',
    'Reporte bonos redimidos': 'Report redeemed bonuses',
    'Fecha Redimió': 'Date Redeemed',
    ERROR10001: 'There is a transaction for the supplier',
    ERROR10002: 'Negative amount',
    ERROR10003: 'Ticket value different from rollback',
    ERROR10004: 'Debit with rollback before',
    ERROR10005: 'The transaction does not exist',
    ERROR10006: 'The transaction is not debit',
    ERROR10007: 'Transaction details do not match',
    ERROR10008: 'Different previous transaction value',
    ERROR10009: '',
    ERROR10010: 'Game Transaction Exists',
    ERROR10011: 'Empty token',
    ERROR10012: 'Token already exists',
    ERROR10013: 'UID vacío',
    ERROR10014: '# Debit different from # Credit',
    ERROR10015: 'Transaction with rollback',
    ERROR10016: 'Closed round',
    ERROR10017: 'Incorrect Currency',
    ERROR10018: 'Wrong country code',
    ERROR10019: '',
    ERROR10020: 'Empty field',
    ERROR10021: 'User Id empty',
    ERROR10022: '',
    ERROR10023: '',
    ERROR10024: '',
    ERROR10025: 'Ticket ID already exists',
    ERROR10026: 'Ticket ID does not exist',
    ERROR10030: 'Inactive Token',
    ERROR10031: 'Wrong BettypeID Ezugi',
    ERROR10027: 'The ticket is already closed',
    ERROR19000: 'The ID already exists',
    ERROR19001: 'The login is already registered',
    ERROR20000: 'User session expired or invalid',
    ERROR20001: 'Insufficient funds',
    ERROR20002: 'Wrong SIGN',
    ERROR20003: 'Inactive User',
    ERROR20004: 'Self-exclusion Casino Internal Product',
    ERROR20005: 'Self-exclusion Casino Category',
    ERROR20006: 'Autoexclusion Casino SubCategory',
    ERROR20007: 'Self-exclusion Casino Game',
    ERROR20008: 'Simple deposit limit',
    ERROR20009: 'Daily deposit limit',
    ERROR20010: 'Weekly deposit limit',
    ERROR20011: 'Monthly deposit limit',
    ERROR20012: 'Annual deposit limit',
    ERROR20013: 'Simple casino limit',
    ERROR20014: 'Daily casino limit',
    ERROR20015: 'Weekly casino limit',
    ERROR20016: 'Monthly casino limit',
    ERROR20017: 'Annual casino limit',
    ERROR20018: 'Simple Live Casino Limit',
    ERROR20019: 'Daily Live Casino Limit',
    ERROR20020: 'Weekly Live Casino Limit',
    ERROR20021: 'Monthly Live Casino Limit',
    ERROR20022: 'Annual Live Casino Limit',
    ERROR20023: 'Casino Inactive',
    ERROR20024: 'Casino in Contingency',
    ERROR20025: 'LiveCasino Inactive',
    ERROR20026: 'LiveCasino in Contingency',
    ERROR20027: 'Total self-excluded user by time',
    ERROR20028: 'Total self-excluded user',
    ERROR20029: 'The user is not registered on the platform (Deleted)',
    ERROR21000: 'The withdrawal number is not found',
    ERROR21001: 'The withdrawal has already been processed',
    ERROR21002: 'Value less than the minimum allowed to withdraw',
    ERROR21003: 'Value greater than the maximum allowed to withdraw',
    ERROR21004: 'The account needs to be verified in order to withdraw',
    ERROR21005: 'The registration must be approved in order to withdraw',
    ERROR21006: 'Account needs to be verified to be able to deposit',
    ERROR21007: 'The registry must be approved to be able to deposit',
    ERROR21008: 'Value less than the minimum allowed to deposit',
    ERROR21009: 'Value greater than the maximum allowed to deposit',
    ERROR21010: 'Product not avilable',
    ERROR21011: 'You have the maximum number of active withdrawal notes allowed',
    ERROR30001: 'User Blocked for minimum number of incorrect logins',
    ERROR30002: 'User (Login) does not exist',
    ERROR30003: 'Login with incorrect password',
    ERROR30004: 'At the moment we are in the process of maintaining the site',
    ERROR30005: 'User with inactive registration',
    ERROR30006: 'User exceeds the number of registered bank accounts allowed',
    ERROR30007: 'The password entered is incorrect',
    ERROR30008: 'The voucher code entered is incorrect',
    ERROR30009: 'Wallet not configured -> QUISK',
    ERROR30010: 'You cannot log into the site.',
    ERROR30011: 'User does not match token',
    ERROR30012: 'Player Id was not found for the roundId',
    ERROR30013: 'Game was not found for the roundId',
    ERROR30014: 'UserId is different from the Wager UserId that needed to be cancelled',
    ERROR30015: '',
    ERROR30017: 'The round has already been completed',
    ERROR30018: 'The round has already been completed',
    ERROR30020: '',
    ERROR30021: '',
    ERROR50001: '',
    ERROR50002: 'Loyalty bonus not available',
    ERROR50030: 'The round has already been completed',
    ERROR60001: '',
    ERROR60002: 'Error in sent data',
    ERROR60003: 'The request to the client was empty',
    ERROR100000: '',
    ERROR100001: 'debitTransaction in Ezugi is empty',
    ERROR100002: '',
    ERROR100003: 'Rejected by Automation',
    ERROR100004: 'Needs approval by automation',
    ERROR100005: 'User does not belong to the parnet',
    ERROR100010: '',
    ERROR100011: '',
    ERROR100012: 'General Error',
    ERROR100013: 'Error in sent parameters',
    ERROR100030: 'Point of sale does not have space available to recharge',
    'Fecha de creación punto de venta': 'BetShop creation date',
    Categorización: 'Categorization',
    'Categorización masiva': 'Massive categorization',
    'Con Eliminadas?': 'Include Rejected?',
    'Historial de puntos': 'Points history',
    'Reporte de puntos lealtad': 'Loyalty points report',
    'Usuario Aprueba': 'User Approves',
    'Porcentaje valor de depósitos': 'Percentage value of deposits',
    'Especifique el porcentaje del valor de depositos a mostrar en los reportes':
        'Specify the percentage of the value of deposits to show in the reports',
    'Porcentaje premios no deportivos': 'Percentage of non-sports prizes',
    'Especifique el porcentaje de los premios no deportivos a mostrar en los reportes':
        'Specify the percentage of non-sports awards to show in reports',
    'Porcentaje valor de retiros': 'Percentage value of withdrawals',
    'Especifique el porcentaje del valor de retiros a mostrar en los reportes':
        'Specify the percentage of the withdrawal value to show in the reports',
    'Porcentaje de bonos deportivos': 'Sports Bonus Percentage',
    'Especifique el porcentaje de los bonos deportivos a mostrar en los reportes':
        'Specify the percentage of sports bonuses to show in the reports',
    'Porcentaje de apuestas deportivas': 'Sports betting percentage',
    'Especifique el porcentaje de las apuestas deportivas a mostrar en los reportes':
        'Specify the percentage of sports bets to show in the reports',
    'Porcentaje de bonos no deportivos': 'Percentage of non-sports bonuses',
    'Especifique el porcentaje de los bonos no deportivos a mostrar en los reportes':
        'Specify the percentage of non-sports bonuses to show in the reports',
    'Porcentaje de apuestas no deportivas': 'Percentage of non-sports bets',
    'Especifique el porcentaje de las apuestas no deportivas a mostrar en los reportes':
        'Specify the percentage of non-sports bets to show in the reports',
    'Porcentaje de tickets': 'Percentage of tickets',
    'Especifique el porcentaje de los tickets a mostrar en los reportes':
        'Specify the percentage of tickets to show in the reports',
    'Porcentaje de premios deportivos': 'Sports prize percentage',
    'Especifique el porcentaje de los premios deportivos a mostrar en los reportes':
        'Specify the percentage of sports prizes to show in the reports',
    'No puedes acceder desde esta IP.': 'You cannot access from this IP.',
    'El usuario ha sido bloqueado por el sistema debido a que excedió el número de intentos permitidos con clave errónea.   (Report#30001)':
        'The user has been blocked by the system because he exceeded the number of attempts allowed with the wrong password.',
    'Site Builderg': 'Site Builder',
    'Reporte de bonos -': 'Redeemed Bonus Report',
    'Reporte Comisiones Global -': 'Global Commissions Report',
    'Pagar Comisiones': 'Commissions Payout',
    'Comisiones Pagadas': 'Paid Commissions',
    'Premios Lealtad': 'Loyalty Rewards',
    'Solicitudes de retiro retail': 'Retail Withdrawal Requests',
    'Saldo de comisión': 'Commission Balance',
    'Imagen cuadrada': 'Square Image',
    'Id Codigo Promocional': 'Promotional Code ID',
    'Reporte de bonos redimidos': 'Redeemed Bonus Report',
    'Nombre Usuario REF': 'Username REF',
    'Mi comisión': 'My commission',
    'Pago de comisiones': 'Commisions Payout',
    'Pagar comisiones': 'Commisions Payout',
    'Reporte de comisiones pagadas': 'Paid Commissions',
    'Por fecha de comisión pagado': 'By Paid Commission Date',
    ' Estado': 'State',
    Pagado: 'Paid out',
    'Id Regalo': 'Gift ID',
    'Premios lealtad': 'Loyalty Rewards',
    Comprado: 'Bought',
    Entregado: 'Delivered',
    'Fecha Modificó': 'Date Modified',
    'Id Usuario': 'User ID',
    'Id Casino': 'Casino ID',
    'Descripción Premio': 'Reward Description',
    'Tipo Premio': 'Reward Type',
    'Forma Pago': 'Payment Method',
    'ID Partnert': 'Partner ID',
    'Número cédula': 'Personal ID Number',
    'Direccion IP': 'IP Address',
    'Fecha Modificado': 'Modified Date',
    'Impuesto 2': 'Tax 2',
    'Valor final': 'Final Amount',
    'Sumar Saldo': 'Add Balance',
    'Restar Saldo': 'Subtract Balance',
    'Canal de pago': 'Payment channel',
    'Pendiente por aprobación': 'Pending approval',
    Procesando: 'Processing',
};

// FILE DOCUMENTED
